<template>
  <div
    class="menu-sidebar sb-main bg-white border-right"
    :class="extraSidebar ? 'side-bar-extra' : 'side-bar-default'"
  >
    <div data-toggle="tooltip" data-placement="right">
      <div :class="finished_info ? '' : 'pe-none'">
        <div class="sb-link m-0">
          <div style="width: 44px" @click="onOpenSidebar">
            <div class="sb-link-content" style="width: 44px">
              <span class="sb-icon">
                <svg
                  :class="extraSidebar ? 'fliped' : ''"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.9985 6.00001L7.99959 6.16709L8.02529 8.16693L21.0242 7.99985L20.9985 6.00001ZM21.0628 10.9996L11.0636 11.1281L11.0893 13.128L21.0885 12.9994L21.0628 10.9996ZM21.1527 17.999L21.127 15.9992L8.12811 16.1663L8.15381 18.1661L21.1527 17.999ZM3.03098 8.64115L6.65682 12.1848L3.12325 15.8206L4.55126 17.2123L9.48659 12.1485L4.42274 7.21315L3.03098 8.64115Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div v-show="isDoctor">
          <el-menu
            :default-active="indexActive"
            class="Menu-vertical-demo border-0"
            text-color="#03267A"
            active-text-color="#ffffff"
          >
            <!-- <template v-for="(item, index) in menuSidebar">
              <el-menu-item
                v-if="item.mode === mode"
                :key="`${item.name}-${index}`"
              >
                <a v-if="item.is_redirect" :href="item.path" target="_blank">
                  <component :is="item.icon"></component>
                  <span class="fw-500 ml-6">
                    {{
                      item.org_model
                        ? $t(item.title)[item.org_model]
                        : $t(item.title)
                    }}
                  </span>
                </a>
                <router-link :to="item.path" v-else>
                  <component :is="item.icon"></component>
                  <span class="fw-500 ml-6">
                    {{
                      item.org_model
                        ? $t(item.title)[item.org_model]
                        : $t(item.title)
                    }}
                  </span>
                </router-link>
              </el-menu-item>
            </template>-->
            <el-menu-item v-if="mode === 1" index="0">
              <div data-toggle="tooltip" data-placement="right" title="Trang chủ">
                <router-link to="/">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.79 23.25H6.21C3.47 23.25 1.25 21.02 1.25 18.28V10.87C1.25 9.51 2.09 7.8 3.17 6.96L8.56 2.76C10.18 1.5 12.77 1.44 14.45 2.62L20.63 6.95C21.82 7.78 22.75 9.56001 22.75 11.01V18.29C22.75 21.02 20.53 23.25 17.79 23.25ZM9.48 3.94L4.09 8.14C3.38 8.7 2.75 9.97001 2.75 10.87V18.28C2.75 20.19 4.3 21.75 6.21 21.75H17.79C19.7 21.75 21.25 20.2 21.25 18.29V11.01C21.25 10.05 20.56 8.72 19.77 8.18L13.59 3.85C12.45 3.05 10.57 3.09 9.48 3.94Z"
                      fill="currentColor"
                    />
                    <path
                      d="M12 19.25C11.59 19.25 11.25 18.91 11.25 18.5V15.5C11.25 15.09 11.59 14.75 12 14.75C12.41 14.75 12.75 15.09 12.75 15.5V18.5C12.75 18.91 12.41 19.25 12 19.25Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span class="fw-500 ml-6">{{ $t("side_menu.lbl_home") }}</span>
                </router-link>
              </div>
            </el-menu-item>
            <div v-show="mode === 2">
              <el-menu-item index="1">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_organization')"
                >
                  <router-link to="/organization/management">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 15.5H20V12.5C20 12.2348 19.8946 11.9804 19.7071 11.7929C19.5196 11.6054 19.2652 11.5 19 11.5H13V9.5H15C15.2652 9.5 15.5196 9.39464 15.7071 9.20711C15.8946 9.01957 16 8.76522 16 8.5V2.5C16 2.23478 15.8946 1.98043 15.7071 1.79289C15.5196 1.60536 15.2652 1.5 15 1.5H9C8.73478 1.5 8.48043 1.60536 8.29289 1.79289C8.10536 1.98043 8 2.23478 8 2.5V8.5C8 8.76522 8.10536 9.01957 8.29289 9.20711C8.48043 9.39464 8.73478 9.5 9 9.5H11V11.5H5C4.73478 11.5 4.48043 11.6054 4.29289 11.7929C4.10536 11.9804 4 12.2348 4 12.5V15.5H2C1.73478 15.5 1.48043 15.6054 1.29289 15.7929C1.10536 15.9804 1 16.2348 1 16.5V22.5C1 22.7652 1.10536 23.0196 1.29289 23.2071C1.48043 23.3946 1.73478 23.5 2 23.5H8C8.26522 23.5 8.51957 23.3946 8.70711 23.2071C8.89464 23.0196 9 22.7652 9 22.5V16.5C9 16.2348 8.89464 15.9804 8.70711 15.7929C8.51957 15.6054 8.26522 15.5 8 15.5H6V13.5H18V15.5H16C15.7348 15.5 15.4804 15.6054 15.2929 15.7929C15.1054 15.9804 15 16.2348 15 16.5V22.5C15 22.7652 15.1054 23.0196 15.2929 23.2071C15.4804 23.3946 15.7348 23.5 16 23.5H22C22.2652 23.5 22.5196 23.3946 22.7071 23.2071C22.8946 23.0196 23 22.7652 23 22.5V16.5C23 16.2348 22.8946 15.9804 22.7071 15.7929C22.5196 15.6054 22.2652 15.5 22 15.5ZM7 17.5V21.5H3V17.5H7ZM10 7.5V3.5H14V7.5H10ZM21 21.5H17V17.5H21V21.5Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_organization") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item v-if="hasOrgMdt" index="201">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_consultation')"
                >
                  <router-link to="/hoi-chan">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.05 2.51001C10.5 2.51001 9.22998 3.77001 9.22998 5.33001C9.22998 6.89001 10.49 8.15001 12.05 8.15001C13.61 8.15001 14.87 6.89001 14.87 5.33001C14.87 3.77001 13.61 2.51001 12.05 2.51001Z"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M5.04998 14.37C3.49998 14.37 2.22998 15.63 2.22998 17.19C2.22998 18.75 3.48998 20.01 5.04998 20.01C6.60998 20.01 7.86998 18.75 7.86998 17.19C7.86998 15.63 6.59998 14.37 5.04998 14.37Z"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M18.9499 14.37C17.3999 14.37 16.1299 15.63 16.1299 17.19C16.1299 18.75 17.3899 20.01 18.9499 20.01C20.5099 20.01 21.7699 18.75 21.7699 17.19C21.7699 15.63 20.5099 14.37 18.9499 14.37Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M17.6255 6.47439C17.1946 6.12895 16.5652 6.19825 16.2198 6.62917C15.8743 7.06009 15.9436 7.68945 16.3745 8.03489L17.6255 6.47439ZM19.748 11.5L18.7795 11.7493L19.748 11.5ZM18.9053 12.345C18.9957 12.8898 19.5106 13.2583 20.0555 13.1679C20.6003 13.0775 20.9687 12.5626 20.8784 12.0178L18.9053 12.345ZM16.3745 8.03489C17.539 8.96836 18.3974 10.2646 18.7795 11.7493L20.7164 11.2508C20.2238 9.3369 19.119 7.67162 17.6255 6.47439L16.3745 8.03489ZM18.7795 11.7493C18.8298 11.9446 18.8719 12.1433 18.9053 12.345L20.8784 12.0178C20.8353 11.7582 20.7812 11.5024 20.7164 11.2508L18.7795 11.7493Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.0756 21.3908C15.5903 21.1903 15.8449 20.6106 15.6445 20.096C15.444 19.5814 14.8643 19.3267 14.3497 19.5272L15.0756 21.3908ZM9.66208 20.7161L9.93043 19.7528L9.66208 20.7161ZM9.35163 19.5638C8.8346 19.3697 8.25807 19.6314 8.0639 20.1484C7.86973 20.6655 8.13146 21.242 8.64849 21.4362L9.35163 19.5638ZM14.3497 19.5272C12.959 20.0689 11.4073 20.1642 9.93043 19.7528L9.39372 21.6794C11.2975 22.2097 13.2921 22.0855 15.0756 21.3908L14.3497 19.5272ZM9.93043 19.7528C9.73613 19.6986 9.54302 19.6357 9.35163 19.5638L8.64849 21.4362C8.89477 21.5286 9.14341 21.6097 9.39372 21.6794L9.93043 19.7528Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.37453 6.47439C6.80545 6.12895 7.43481 6.19825 7.78025 6.62917C8.12569 7.06009 8.05639 7.68945 7.62547 8.03489L6.37453 6.47439ZM4.25204 11.5L5.22047 11.7493L4.25204 11.5ZM5.09468 12.345C5.00432 12.8898 4.48939 13.2583 3.94455 13.1679C3.3997 13.0775 3.03127 12.5626 3.12163 12.0178L5.09468 12.345ZM7.62547 8.03489C6.46101 8.96836 5.6026 10.2646 5.22047 11.7493L3.2836 11.2508C3.77619 9.3369 4.88103 7.67162 6.37453 6.47439L7.62547 8.03489ZM5.22047 11.7493C5.1702 11.9446 5.12813 12.1433 5.09468 12.345L3.12163 12.0178C3.16468 11.7582 3.21883 11.5024 3.2836 11.2508L5.22047 11.7493Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span class="fw-500 ml-6">
                      {{
                      $t("side_menu.lbl_consultation")
                      }}
                    </span>
                  </router-link>
                </div>
              </el-menu-item>
            </div>
            <el-menu-item v-if="hasConference" index="200">
              <router-link
                v-if="mode === 1"
                to="/conference"
                data-toggle="tooltip"
                data-placement="right"
                :title="$t('conference.lbl_conference')"
                class="relative"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 17C8.38071 17 9.5 15.8807 9.5 14.5C9.5 13.1193 8.38071 12 7 12C5.61929 12 4.5 13.1193 4.5 14.5C4.5 15.8807 5.61929 17 7 17Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 17C18.3807 17 19.5 15.8807 19.5 14.5C19.5 13.1193 18.3807 12 17 12C15.6193 12 14.5 13.1193 14.5 14.5C14.5 15.8807 15.6193 17 17 17Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 7C13.3807 7 14.5 5.88071 14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5C9.5 5.88071 10.6193 7 12 7Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 22C12 19.2386 9.7614 17 7 17C4.23857 17 2 19.2386 2 22"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 22C22 19.2386 19.7614 17 17 17C14.2386 17 12 19.2386 12 22"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 12C17 9.2386 14.7614 7 12 7C9.2386 7 7 9.2386 7 12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="fw-500 ml-6 relative">{{ $t("conference.lbl_conference") }}</span>
                <div class="absolute -top-2 right-0">
                  <span class="cs-new">{{ $t("circle_feature.lbl_new") }}</span>
                </div>
              </router-link>
              <div v-else-if="mode === 2">
                <router-link
                  to="/organization/conference-list"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('conference.lbl_conference_management')"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 17C8.38071 17 9.5 15.8807 9.5 14.5C9.5 13.1193 8.38071 12 7 12C5.61929 12 4.5 13.1193 4.5 14.5C4.5 15.8807 5.61929 17 7 17Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 17C18.3807 17 19.5 15.8807 19.5 14.5C19.5 13.1193 18.3807 12 17 12C15.6193 12 14.5 13.1193 14.5 14.5C14.5 15.8807 15.6193 17 17 17Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 7C13.3807 7 14.5 5.88071 14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5C9.5 5.88071 10.6193 7 12 7Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 22C12 19.2386 9.7614 17 7 17C4.23857 17 2 19.2386 2 22"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 22C22 19.2386 19.7614 17 17 17C14.2386 17 12 19.2386 12 22"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 12C17 9.2386 14.7614 7 12 7C9.2386 7 7 9.2386 7 12"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("conference.lbl_conference_management") }}</span>
                </router-link>
              </div>
            </el-menu-item>
            <!-- TODO -->
            <div v-show="mode === 2">
              <el-menu-item index="15" :disabled="isDisableLivestreamMenu" v-if="false">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_livestream')"
                >
                  <router-link to="/livestream">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.8163 15.6205C15.8163 17.6135 14.4583 19.0215 12.2863 19.0215H6.06929C3.89929 19.0215 2.55029 17.6135 2.55029 15.6205V8.66049C2.55029 6.66849 3.89929 5.25049 6.08029 5.25049H12.2863C14.4583 5.25049 15.8163 6.66849 15.8163 8.66049V15.6205Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 11.5823L20.097 8.22827C20.747 7.69327 21.734 8.15827 21.734 9.00527V15.8773C21.734 16.7253 20.747 17.1883 20.097 16.6543L16 13.3003"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_livestream") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="4">
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_workspace')[$orgModel]">
                  <router-link to="/organization/workspace" class="relative">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.15722 21.2714V18.2047C9.1572 17.4246 9.79312 16.7908 10.581 16.7856H13.4671C14.2587 16.7856 14.9005 17.4209 14.9005 18.2047V18.2047V21.2809C14.9003 21.9432 15.4343 22.4845 16.103 22.5H18.0271C19.9451 22.5 21.5 20.9607 21.5 19.0618V19.0618V10.3378C21.4898 9.59083 21.1355 8.88935 20.538 8.43303L13.9577 3.1853C12.8049 2.27157 11.1662 2.27157 10.0134 3.1853L3.46203 8.44256C2.86226 8.89702 2.50739 9.59967 2.5 10.3474V19.0618C2.5 20.9607 4.05488 22.5 5.97291 22.5H7.89696C8.58235 22.5 9.13797 21.9499 9.13797 21.2714V21.2714"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 9H15C15.2761 9 15.5 9.22386 15.5 9.5C15.5 9.77614 15.2761 10 15 10H9C8.72386 10 8.5 9.77614 8.5 9.5C8.5 9.22386 8.72386 9 9 9Z"
                        stroke="currentColor"
                      />
                      <path
                        d="M12.5 6.5L12.5 12.5C12.5 12.7761 12.2761 13 12 13C11.7239 13 11.5 12.7761 11.5 12.5L11.5 6.5C11.5 6.22386 11.7239 6 12 6C12.2761 6 12.5 6.22386 12.5 6.5Z"
                        stroke="currentColor"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_workspace")[$orgModel] }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="5">
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_personnel')">
                  <router-link to="/manage" class="relative">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.71 13.21C16.6904 12.4387 17.406 11.3809 17.7572 10.1839C18.1085 8.98697 18.0779 7.71027 17.6698 6.53147C17.2617 5.35267 16.4963 4.33039 15.4801 3.60686C14.4639 2.88332 13.2474 2.49451 12 2.49451C10.7525 2.49451 9.53611 2.88332 8.51993 3.60686C7.50374 4.33039 6.73834 5.35267 6.33021 6.53147C5.92208 7.71027 5.89151 8.98697 6.24276 10.1839C6.59401 11.3809 7.3096 12.4387 8.29 13.21C6.61007 13.883 5.14428 14.9994 4.04889 16.4399C2.95349 17.8805 2.26956 19.5913 2.07 21.39C2.05555 21.5213 2.06711 21.6542 2.10402 21.7811C2.14093 21.9079 2.20246 22.0263 2.28511 22.1293C2.45202 22.3375 2.69478 22.4708 2.96 22.5C3.22521 22.5292 3.49116 22.4518 3.69932 22.2849C3.90749 22.118 4.04082 21.8752 4.07 21.61C4.28958 19.6552 5.22168 17.8498 6.68822 16.5388C8.15475 15.2278 10.0529 14.503 12.02 14.503C13.9871 14.503 15.8852 15.2278 17.3518 16.5388C18.8183 17.8498 19.7504 19.6552 19.97 21.61C19.9972 21.8557 20.1144 22.0827 20.2991 22.247C20.4838 22.4114 20.7228 22.5015 20.97 22.5H21.08C21.3421 22.4698 21.5817 22.3373 21.7466 22.1313C21.9114 21.9252 21.9881 21.6624 21.96 21.4C21.7595 19.5962 21.0719 17.881 19.9708 16.4382C18.8698 14.9954 17.3969 13.8795 15.71 13.21ZM12 12.5C11.2089 12.5 10.4355 12.2654 9.77772 11.8259C9.11992 11.3864 8.60723 10.7616 8.30448 10.0307C8.00173 9.29983 7.92251 8.49557 8.07686 7.71964C8.2312 6.94372 8.61216 6.23099 9.17157 5.67158C9.73098 5.11217 10.4437 4.7312 11.2196 4.57686C11.9956 4.42252 12.7998 4.50173 13.5307 4.80448C14.2616 5.10724 14.8863 5.61993 15.3259 6.27772C15.7654 6.93552 16 7.70888 16 8.5C16 9.56087 15.5786 10.5783 14.8284 11.3284C14.0783 12.0786 13.0609 12.5 12 12.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_personnel") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-submenu index="120">
                <template slot="title">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27 8H22V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4H13C12.2044 4 11.4413 4.31607 10.8787 4.87868C10.3161 5.44129 10 6.20435 10 7V8H5C4.46957 8 3.96086 8.21071 3.58579 8.58579C3.21071 8.96086 3 9.46957 3 10V26C3 26.5304 3.21071 27.0391 3.58579 27.4142C3.96086 27.7893 4.46957 28 5 28H27C27.5304 28 28.0391 27.7893 28.4142 27.4142C28.7893 27.0391 29 26.5304 29 26V10C29 9.46957 28.7893 8.96086 28.4142 8.58579C28.0391 8.21071 27.5304 8 27 8ZM12 7C12 6.73478 12.1054 6.48043 12.2929 6.29289C12.4804 6.10536 12.7348 6 13 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V8H12V7ZM27 26H5V10H27V26ZM20 18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H17V21C17 21.2652 16.8946 21.5196 16.7071 21.7071C16.5196 21.8946 16.2652 22 16 22C15.7348 22 15.4804 21.8946 15.2929 21.7071C15.1054 21.5196 15 21.2652 15 21V19H13C12.7348 19 12.4804 18.8946 12.2929 18.7071C12.1054 18.5196 12 18.2652 12 18C12 17.7348 12.1054 17.4804 12.2929 17.2929C12.4804 17.1054 12.7348 17 13 17H15V15C15 14.7348 15.1054 14.4804 15.2929 14.2929C15.4804 14.1054 15.7348 14 16 14C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15V17H19C19.2652 17 19.5196 17.1054 19.7071 17.2929C19.8946 17.4804 20 17.7348 20 18Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("Quản lý Dịch vụ") }}</span>
                </template>

                <el-menu-item index="120-1">
                  <router-link to="/service-management" class="relative">
                    <span class="fw-500 ml-16">{{ $t("Danh mục dịch vụ") }}</span>
                  </router-link>
                </el-menu-item>
                <el-menu-item index="120-2">
                  <router-link to="/service-catalog" class="relative">
                    <span class="fw-500 ml-16">{{ $t("Dịch vụ") }}</span>
                  </router-link>
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-if="hasPharma" index="20">
                <div data-toggle="tooltip" :title="$t('Kho thuốc')">
                  <a :href="linkPharma" target="_blank" class="relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.4999 4.49996C18.5398 3.54001 17.2377 3.00073 15.8799 3.00073C14.5222 3.00073 13.2201 3.54001 12.2599 4.49996L4.49994 12.26C4.01308 12.7328 3.62509 13.2977 3.35852 13.9218C3.09195 14.5459 2.95212 15.2168 2.94716 15.8955C2.9422 16.5741 3.07221 17.247 3.32963 17.8749C3.58705 18.5029 3.96675 19.0734 4.44663 19.5533C4.92652 20.0331 5.49703 20.4128 6.12498 20.6703C6.75293 20.9277 7.42579 21.0577 8.10444 21.0527C8.78309 21.0478 9.45398 20.9079 10.0781 20.6414C10.7022 20.3748 11.2671 19.9868 11.7399 19.5L19.4999 11.74C20.4599 10.7798 20.9992 9.47768 20.9992 8.11996C20.9992 6.76224 20.4599 5.46011 19.4999 4.49996ZM10.3199 18.09C9.72397 18.6533 8.935 18.9671 8.11494 18.9671C7.29487 18.9671 6.50591 18.6533 5.90994 18.09C5.32797 17.5037 5.00139 16.7111 5.00139 15.885C5.00139 15.0589 5.32797 14.2663 5.90994 13.68L9.08994 10.5L13.4999 14.91L10.3199 18.09ZM18.0899 10.32L14.9099 13.5L10.4999 9.08996L13.6799 5.90996C14.271 5.35628 15.0541 5.05411 15.8639 5.06731C16.6736 5.08052 17.4465 5.40807 18.0192 5.98072C18.5918 6.55338 18.9194 7.32627 18.9326 8.13602C18.9458 8.94577 18.6436 9.72893 18.0899 10.32Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("Kho thuốc") }}</span>
                  </a>
                </div>
              </el-menu-item>
              <el-menu-item v-if="hasEcom" index="6">
                <div
                  data-toggle="tooltip"
                  :title="
                    $t(
                      isProcessor
                        ? 'side_menu.lbl_ecommerce.hospital'
                        : 'side_menu.lbl_ecommerce.hospital'
                    )
                  "
                >
                  <router-link to="/organization/ecom" class="relative">
                    <svg
                      xmlns:x="http://ns.adobe.com/Extensibility/1.0/"
                      xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"
                      xmlns:graph="http://ns.adobe.com/Graphs/1.0/"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 125"
                      style="
                        enable-background: new 0 0 100 100;
                        margin-top: 5px;
                      "
                      xml:space="preserve"
                      width="24"
                    >
                      <switch>
                        <foreignObject
                          requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
                          x="0"
                          y="0"
                          width="1"
                          height="1"
                        />
                        <g i:extraneous="self">
                          <g>
                            <path
                              fill="#03267a"
                              d="M65.8,55.2H34.2L17.6,81.8c-0.7,1-0.4,2-0.1,2.6c0.2,0.5,0.9,1.3,2.2,1.3h60.6c1.2,0,1.9-0.7,2.2-1.3     c0.3-0.5,0.6-1.5-0.1-2.6L65.8,55.2z"
                            />
                            <path
                              fill="#03267a"
                              d="M92.5,75.6L67.1,34.8c-0.7-1.2-1.1-2.6-1.1-4V9.3h2.7c1.9,0,3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4H31.4C29.5,2.5,28,4,28,5.9     s1.5,3.4,3.4,3.4h2.7v21.5c0,1.4-0.4,2.8-1.1,4L7.5,75.6c-2.8,4.5-2.9,9.9-0.4,14.5c2.6,4.6,7.2,7.4,12.5,7.4h60.6     c5.3,0,10-2.8,12.5-7.4C95.4,85.5,95.2,80.1,92.5,75.6z M86.9,86.9c-1.4,2.4-3.8,3.9-6.6,3.9H19.7c-2.8,0-5.3-1.5-6.6-3.9     c-1.4-2.4-1.3-5.3,0.2-7.7l25.4-40.8c1.4-2.3,2.2-4.9,2.2-7.6V9.3h18.4v21.5c0,2.7,0.7,5.3,2.2,7.6l25.4,40.8     C88.2,81.5,88.3,84.4,86.9,86.9z"
                            />
                          </g>
                        </g>
                      </switch>
                    </svg>

                    <span class="fw-500 ml-6">
                      {{
                      $t(
                      isProcessor
                      ? "side_menu.lbl_ecommerce.hospital"
                      : "side_menu.lbl_ecommerce.hospital"
                      )
                      }}
                    </span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-submenu v-if="hasHODOCredit" index="123">
                <template slot="title">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28 6H4C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8V24C2 24.5304 2.21071 25.0391 2.58579 25.4142C2.96086 25.7893 3.46957 26 4 26H28C28.5304 26 29.0391 25.7893 29.4142 25.4142C29.7893 25.0391 30 24.5304 30 24V8C30 7.46957 29.7893 6.96086 29.4142 6.58579C29.0391 6.21071 28.5304 6 28 6ZM28 8V11H4V8H28ZM28 24H4V13H28V24ZM26 21C26 21.2652 25.8946 21.5196 25.7071 21.7071C25.5196 21.8946 25.2652 22 25 22H21C20.7348 22 20.4804 21.8946 20.2929 21.7071C20.1054 21.5196 20 21.2652 20 21C20 20.7348 20.1054 20.4804 20.2929 20.2929C20.4804 20.1054 20.7348 20 21 20H25C25.2652 20 25.5196 20.1054 25.7071 20.2929C25.8946 20.4804 26 20.7348 26 21ZM18 21C18 21.2652 17.8946 21.5196 17.7071 21.7071C17.5196 21.8946 17.2652 22 17 22H15C14.7348 22 14.4804 21.8946 14.2929 21.7071C14.1054 21.5196 14 21.2652 14 21C14 20.7348 14.1054 20.4804 14.2929 20.2929C14.4804 20.1054 14.7348 20 15 20H17C17.2652 20 17.5196 20.1054 17.7071 20.2929C17.8946 20.4804 18 20.7348 18 21Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("HODO Credit") }}</span>
                </template>
                <!-- <el-menu-item index="123-3">
                  <router-link
                    to="/organization/credit/config"
                    class="relative"
                  >
                    <span class="fw-500 ml-16">{{
                      $t("Thiết lập tỷ lệ")
                    }}</span>
                  </router-link>
                </el-menu-item>-->
                <el-menu-item index="123-2">
                  <router-link to="/organization/credit/deposit" class="relative">
                    <span class="fw-500 ml-16">{{ $t("Nạp điểm") }}</span>
                  </router-link>
                </el-menu-item>
                <!-- <el-menu-item index="123-1">
                  <router-link
                    to="/organization/credit/accumulate"
                    class="relative"
                  >
                    <span class="fw-500 ml-16">{{ $t("Tích điểm") }}</span>
                  </router-link>
                </el-menu-item>-->
              </el-submenu>
              <el-menu-item v-if="hasManageEcomMK" index="124">
                <div data-toggle="tooltip" :title="$t('Quản lý chợ')">
                  <a :href="linkMarketplaceWarehouse" target="_blank" class="relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="currentColor"
                        d="M4 19h2v-8h12v8h2V8.35l-8-3.2l-8 3.2zm-2 2V7l10-4l10 4v14h-6v-8H8v8zm7 0v-2h2v2zm2-3v-2h2v2zm2 3v-2h2v2zM6 11h12z"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("Quản lý chợ") }}</span>
                  </a>
                </div>
              </el-menu-item>
              <el-menu-item index="7" disabled>
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_report')">
                  <router-link to="/" class="relative cursor-not-allowed hover:no-underline">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 6.5C11.7348 6.5 11.4804 6.60536 11.2929 6.79289C11.1054 6.98043 11 7.23478 11 7.5V17.5C11 17.7652 11.1054 18.0196 11.2929 18.2071C11.4804 18.3946 11.7348 18.5 12 18.5C12.2652 18.5 12.5196 18.3946 12.7071 18.2071C12.8946 18.0196 13 17.7652 13 17.5V7.5C13 7.23478 12.8946 6.98043 12.7071 6.79289C12.5196 6.60536 12.2652 6.5 12 6.5ZM7 12.5C6.73478 12.5 6.48043 12.6054 6.29289 12.7929C6.10536 12.9804 6 13.2348 6 13.5V17.5C6 17.7652 6.10536 18.0196 6.29289 18.2071C6.48043 18.3946 6.73478 18.5 7 18.5C7.26522 18.5 7.51957 18.3946 7.70711 18.2071C7.89464 18.0196 8 17.7652 8 17.5V13.5C8 13.2348 7.89464 12.9804 7.70711 12.7929C7.51957 12.6054 7.26522 12.5 7 12.5ZM17 10.5C16.7348 10.5 16.4804 10.6054 16.2929 10.7929C16.1054 10.9804 16 11.2348 16 11.5V17.5C16 17.7652 16.1054 18.0196 16.2929 18.2071C16.4804 18.3946 16.7348 18.5 17 18.5C17.2652 18.5 17.5196 18.3946 17.7071 18.2071C17.8946 18.0196 18 17.7652 18 17.5V11.5C18 11.2348 17.8946 10.9804 17.7071 10.7929C17.5196 10.6054 17.2652 10.5 17 10.5ZM19 2.5H5C4.20435 2.5 3.44129 2.81607 2.87868 3.37868C2.31607 3.94129 2 4.70435 2 5.5V19.5C2 20.2956 2.31607 21.0587 2.87868 21.6213C3.44129 22.1839 4.20435 22.5 5 22.5H19C19.7956 22.5 20.5587 22.1839 21.1213 21.6213C21.6839 21.0587 22 20.2956 22 19.5V5.5C22 4.70435 21.6839 3.94129 21.1213 3.37868C20.5587 2.81607 19.7956 2.5 19 2.5ZM20 19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H5C4.73478 20.5 4.48043 20.3946 4.29289 20.2071C4.10536 20.0196 4 19.7652 4 19.5V5.5C4 5.23478 4.10536 4.98043 4.29289 4.79289C4.48043 4.60536 4.73478 4.5 5 4.5H19C19.2652 4.5 19.5196 4.60536 19.7071 4.79289C19.8946 4.98043 20 5.23478 20 5.5V19.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_report") }}</span>
                  </router-link>
                </div>
              </el-menu-item>

              <el-menu-item index="8" disabled>
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_resources')">
                  <router-link to="/" class="relative cursor-not-allowed hover:no-underline">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.7382 10.3267C23.6356 10.172 23.506 10.0474 23.3589 9.96201C23.2118 9.87664 23.0509 9.83267 22.8881 9.83335H20.7083V8.50002C20.7083 7.43915 20.3638 6.42174 19.7506 5.6716C19.1374 4.92145 18.3057 4.50002 17.4386 4.50002H10.5939L10.2451 3.16669C10.019 2.38433 9.59965 1.70737 9.04505 1.22958C8.49045 0.751787 7.82812 0.496831 7.14981 0.50003H3.26973C2.40254 0.50003 1.57087 0.921457 0.957681 1.6716C0.344488 2.42175 0 3.43916 0 4.50002V20.5C0 21.5609 0.344488 22.5783 0.957681 23.3284C1.57087 24.0786 2.40254 24.5 3.26973 24.5H18.9644C19.7069 24.4974 20.4265 24.1857 21.0049 23.6162C21.5833 23.0467 21.9861 22.2534 22.147 21.3667L23.978 11.46C24.0112 11.2612 24.0068 11.0558 23.9652 10.8594C23.9237 10.663 23.846 10.4808 23.7382 10.3267ZM4.7629 20.7933C4.70753 21.0941 4.56867 21.3621 4.36995 21.5517C4.17123 21.7414 3.92494 21.8409 3.67299 21.8333H3.26973C2.98067 21.8333 2.70344 21.6929 2.49905 21.4428C2.29465 21.1928 2.17982 20.8536 2.17982 20.5V4.50002C2.17982 4.1464 2.29465 3.80727 2.49905 3.55722C2.70344 3.30717 2.98067 3.16669 3.26973 3.16669H7.14981C7.38748 3.15152 7.62268 3.23193 7.81948 3.39565C8.01629 3.55936 8.16388 3.79738 8.23972 4.07336L8.82827 6.26002C8.89821 6.51435 9.02925 6.73694 9.20425 6.8987C9.37926 7.06046 9.59009 7.15386 9.80919 7.16669H17.4386C17.7276 7.16669 18.0048 7.30716 18.2092 7.55721C18.4136 7.80726 18.5285 8.1464 18.5285 8.50002V9.83335H7.62937C7.37742 9.82582 7.13113 9.92533 6.93241 10.1149C6.73369 10.3046 6.59483 10.5726 6.53946 10.8734L4.7629 20.7933ZM20.0216 20.7933C19.9663 21.0941 19.8274 21.3621 19.6287 21.5517C19.43 21.7414 19.1837 21.8409 18.9317 21.8333H6.76834C6.82463 21.6848 6.86493 21.5279 6.88823 21.3667L8.50129 12.5H21.5802L20.0216 20.7933Z"
                        fill="#20409B"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_resources") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="9" disabled>
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_analysis')">
                  <router-link to="/" class="relative cursor-not-allowed hover:no-underline">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 16.5C7.39782 16.5 7.77936 16.342 8.06066 16.0607C8.34196 15.7794 8.5 15.3978 8.5 15C8.50488 14.9501 8.50488 14.8999 8.5 14.85L11.29 12.06H11.52H11.75L13.36 13.67C13.36 13.67 13.36 13.72 13.36 13.75C13.36 14.1478 13.518 14.5294 13.7993 14.8107C14.0806 15.092 14.4622 15.25 14.86 15.25C15.2578 15.25 15.6394 15.092 15.9207 14.8107C16.202 14.5294 16.36 14.1478 16.36 13.75V13.67L20 10C20.2967 10 20.5867 9.91203 20.8334 9.7472C21.08 9.58238 21.2723 9.34811 21.3858 9.07403C21.4993 8.79994 21.5291 8.49834 21.4712 8.20736C21.4133 7.91639 21.2704 7.64912 21.0607 7.43934C20.8509 7.22956 20.5836 7.0867 20.2926 7.02882C20.0017 6.97094 19.7001 7.00065 19.426 7.11418C19.1519 7.22771 18.9176 7.41997 18.7528 7.66664C18.588 7.91332 18.5 8.20333 18.5 8.5C18.4951 8.54988 18.4951 8.60012 18.5 8.65L14.89 12.26H14.73L13 10.5C13 10.1022 12.842 9.72064 12.5607 9.43934C12.2794 9.15804 11.8978 9 11.5 9C11.1022 9 10.7206 9.15804 10.4393 9.43934C10.158 9.72064 10 10.1022 10 10.5L7 13.5C6.60218 13.5 6.22064 13.658 5.93934 13.9393C5.65804 14.2206 5.5 14.6022 5.5 15C5.5 15.3978 5.65804 15.7794 5.93934 16.0607C6.22064 16.342 6.60218 16.5 7 16.5ZM20.5 20.5H3.5V3.5C3.5 3.23478 3.39464 2.98043 3.20711 2.79289C3.01957 2.60536 2.76522 2.5 2.5 2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V21.5C1.5 21.7652 1.60536 22.0196 1.79289 22.2071C1.98043 22.3946 2.23478 22.5 2.5 22.5H20.5C20.7652 22.5 21.0196 22.3946 21.2071 22.2071C21.3946 22.0196 21.5 21.7652 21.5 21.5C21.5 21.2348 21.3946 20.9804 21.2071 20.7929C21.0196 20.6054 20.7652 20.5 20.5 20.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_analysis") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="10" v-show="$user && $user.org_id">
                <div cdata-toggle="tooltip" :title="$t('side_menu.lbl_settings')">
                  <router-link :to="`/organization/update/${$user.org_id}`" class="relative">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.32 10.05L19.43 9.42L20.32 7.64C20.4102 7.45369 20.4404 7.24396 20.4064 7.03977C20.3723 6.83558 20.2758 6.64698 20.13 6.5L18 4.37C17.8522 4.22209 17.6618 4.12421 17.4555 4.09013C17.2493 4.05604 17.0375 4.08748 16.85 4.18L15.07 5.07L14.44 3.18C14.3735 2.98299 14.2472 2.81163 14.0787 2.68975C13.9102 2.56787 13.7079 2.50154 13.5 2.5H10.5C10.2904 2.49946 10.0858 2.56482 9.91537 2.68684C9.7449 2.80886 9.61709 2.98138 9.55 3.18L8.92 5.07L7.14 4.18C6.95369 4.08978 6.74397 4.0596 6.53978 4.09364C6.33558 4.12767 6.14699 4.22423 6 4.37L3.87 6.5C3.72209 6.64776 3.62421 6.83817 3.59013 7.04446C3.55605 7.25074 3.58748 7.46251 3.68 7.65L4.57 9.43L2.68 10.06C2.483 10.1265 2.31163 10.2528 2.18975 10.4213C2.06787 10.5898 2.00155 10.7921 2 11V14C1.99946 14.2096 2.06482 14.4142 2.18685 14.5846C2.30887 14.7551 2.48138 14.8829 2.68 14.95L4.57 15.58L3.68 17.36C3.58978 17.5463 3.55961 17.756 3.59364 17.9602C3.62767 18.1644 3.72423 18.353 3.87 18.5L6 20.63C6.14777 20.7779 6.33818 20.8758 6.54446 20.9099C6.75074 20.944 6.96251 20.9125 7.15 20.82L8.93 19.93L9.56 21.82C9.62709 22.0186 9.7549 22.1911 9.92537 22.3132C10.0958 22.4352 10.3004 22.5005 10.51 22.5H13.51C13.7196 22.5005 13.9242 22.4352 14.0946 22.3132C14.2651 22.1911 14.3929 22.0186 14.46 21.82L15.09 19.93L16.87 20.82C17.0551 20.9079 17.2628 20.9369 17.4649 20.9029C17.667 20.8689 17.8538 20.7736 18 20.63L20.13 18.5C20.2779 18.3522 20.3758 18.1618 20.4099 17.9555C20.444 17.7493 20.4125 17.5375 20.32 17.35L19.43 15.57L21.32 14.94C21.517 14.8735 21.6884 14.7472 21.8103 14.5787C21.9321 14.4102 21.9985 14.2079 22 14V11C22.0005 10.7904 21.9352 10.5858 21.8132 10.4154C21.6911 10.2449 21.5186 10.1171 21.32 10.05ZM20 13.28L18.8 13.68C18.5241 13.7695 18.2709 13.918 18.0581 14.1151C17.8452 14.3122 17.6778 14.5533 17.5675 14.8216C17.4571 15.0899 17.4064 15.3789 17.419 15.6688C17.4315 15.9586 17.5069 16.2422 17.64 16.5L18.21 17.64L17.11 18.74L16 18.14C15.7436 18.0122 15.4627 17.9411 15.1763 17.9313C14.89 17.9215 14.6049 17.9734 14.3403 18.0834C14.0758 18.1934 13.8379 18.3589 13.6429 18.5688C13.4479 18.7787 13.3003 19.0281 13.21 19.3L12.81 20.5H11.22L10.82 19.3C10.7305 19.0241 10.582 18.7709 10.3849 18.5581C10.1878 18.3452 9.94671 18.1778 9.67842 18.0675C9.41014 17.9571 9.12105 17.9064 8.83123 17.919C8.5414 17.9315 8.25777 18.0069 8 18.14L6.86 18.71L5.76 17.61L6.36 16.5C6.4931 16.2422 6.56852 15.9586 6.58105 15.6688C6.59358 15.3789 6.5429 15.0899 6.43254 14.8216C6.32218 14.5533 6.15478 14.3122 5.94195 14.1151C5.72912 13.918 5.47595 13.7695 5.2 13.68L4 13.28V11.72L5.2 11.32C5.47595 11.2305 5.72912 11.082 5.94195 10.8849C6.15478 10.6878 6.32218 10.4467 6.43254 10.1784C6.5429 9.91013 6.59358 9.62105 6.58105 9.33122C6.56852 9.0414 6.4931 8.75776 6.36 8.5L5.79 7.39L6.89 6.29L8 6.86C8.25777 6.99309 8.5414 7.06852 8.83123 7.08105C9.12105 7.09357 9.41014 7.0429 9.67842 6.93254C9.94671 6.82218 10.1878 6.65478 10.3849 6.44194C10.582 6.22911 10.7305 5.97594 10.82 5.7L11.22 4.5H12.78L13.18 5.7C13.2695 5.97594 13.418 6.22911 13.6151 6.44194C13.8122 6.65478 14.0533 6.82218 14.3216 6.93254C14.5899 7.0429 14.879 7.09357 15.1688 7.08105C15.4586 7.06852 15.7422 6.99309 16 6.86L17.14 6.29L18.24 7.39L17.64 8.5C17.5122 8.75644 17.4411 9.03735 17.4313 9.32369C17.4215 9.61003 17.4734 9.89513 17.5834 10.1597C17.6934 10.4242 17.8589 10.6621 18.0688 10.8571C18.2787 11.0521 18.5281 11.1997 18.8 11.29L20 11.69V13.28ZM12 8.5C11.2089 8.5 10.4355 8.7346 9.77772 9.17412C9.11993 9.61365 8.60724 10.2384 8.30448 10.9693C8.00173 11.7002 7.92252 12.5044 8.07686 13.2804C8.2312 14.0563 8.61217 14.769 9.17158 15.3284C9.73099 15.8878 10.4437 16.2688 11.2196 16.4231C11.9956 16.5775 12.7998 16.4983 13.5307 16.1955C14.2616 15.8928 14.8864 15.3801 15.3259 14.7223C15.7654 14.0645 16 13.2911 16 12.5C16 11.4391 15.5786 10.4217 14.8284 9.67157C14.0783 8.92143 13.0609 8.5 12 8.5ZM12 14.5C11.6044 14.5 11.2178 14.3827 10.8889 14.1629C10.56 13.9432 10.3036 13.6308 10.1522 13.2654C10.0009 12.8999 9.96126 12.4978 10.0384 12.1098C10.1156 11.7219 10.3061 11.3655 10.5858 11.0858C10.8655 10.8061 11.2219 10.6156 11.6098 10.5384C11.9978 10.4613 12.3999 10.5009 12.7654 10.6522C13.1308 10.8036 13.4432 11.06 13.6629 11.3889C13.8827 11.7178 14 12.1044 14 12.5C14 13.0304 13.7893 13.5391 13.4142 13.9142C13.0391 14.2893 12.5304 14.5 12 14.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_settings") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
            </div>

            <div v-if="mode === 1">
              <el-menu-item index="1" v-show="$globalClinic && hasSkb">
                <router-link
                  to="/health-records"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Sổ Khám Bệnh"
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 14.5H8C7.73478 14.5 7.48043 14.6054 7.29289 14.7929C7.10536 14.9804 7 15.2348 7 15.5C7 15.7652 7.10536 16.0196 7.29289 16.2071C7.48043 16.3946 7.73478 16.5 8 16.5H16C16.2652 16.5 16.5196 16.3946 16.7071 16.2071C16.8946 16.0196 17 15.7652 17 15.5C17 15.2348 16.8946 14.9804 16.7071 14.7929C16.5196 14.6054 16.2652 14.5 16 14.5ZM16 10.5H10C9.73478 10.5 9.48043 10.6054 9.29289 10.7929C9.10536 10.9804 9 11.2348 9 11.5C9 11.7652 9.10536 12.0196 9.29289 12.2071C9.48043 12.3946 9.73478 12.5 10 12.5H16C16.2652 12.5 16.5196 12.3946 16.7071 12.2071C16.8946 12.0196 17 11.7652 17 11.5C17 11.2348 16.8946 10.9804 16.7071 10.7929C16.5196 10.6054 16.2652 10.5 16 10.5ZM20 4.5H17V3.5C17 3.23478 16.8946 2.98043 16.7071 2.79289C16.5196 2.60536 16.2652 2.5 16 2.5C15.7348 2.5 15.4804 2.60536 15.2929 2.79289C15.1054 2.98043 15 3.23478 15 3.5V4.5H13V3.5C13 3.23478 12.8946 2.98043 12.7071 2.79289C12.5196 2.60536 12.2652 2.5 12 2.5C11.7348 2.5 11.4804 2.60536 11.2929 2.79289C11.1054 2.98043 11 3.23478 11 3.5V4.5H9V3.5C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5V4.5H4C3.73478 4.5 3.48043 4.60536 3.29289 4.79289C3.10536 4.98043 3 5.23478 3 5.5V19.5C3 20.2956 3.31607 21.0587 3.87868 21.6213C4.44129 22.1839 5.20435 22.5 6 22.5H18C18.7956 22.5 19.5587 22.1839 20.1213 21.6213C20.6839 21.0587 21 20.2956 21 19.5V5.5C21 5.23478 20.8946 4.98043 20.7071 4.79289C20.5196 4.60536 20.2652 4.5 20 4.5ZM19 19.5C19 19.7652 18.8946 20.0196 18.7071 20.2071C18.5196 20.3946 18.2652 20.5 18 20.5H6C5.73478 20.5 5.48043 20.3946 5.29289 20.2071C5.10536 20.0196 5 19.7652 5 19.5V6.5H7V7.5C7 7.76522 7.10536 8.01957 7.29289 8.20711C7.48043 8.39464 7.73478 8.5 8 8.5C8.26522 8.5 8.51957 8.39464 8.70711 8.20711C8.89464 8.01957 9 7.76522 9 7.5V6.5H11V7.5C11 7.76522 11.1054 8.01957 11.2929 8.20711C11.4804 8.39464 11.7348 8.5 12 8.5C12.2652 8.5 12.5196 8.39464 12.7071 8.20711C12.8946 8.01957 13 7.76522 13 7.5V6.5H15V7.5C15 7.76522 15.1054 8.01957 15.2929 8.20711C15.4804 8.39464 15.7348 8.5 16 8.5C16.2652 8.5 16.5196 8.39464 16.7071 8.20711C16.8946 8.01957 17 7.76522 17 7.5V6.5H19V19.5Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("side_menu.lbl_health_book") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item @click="handleOpenEMR" index="2" v-show="$globalClinic && hasBadt">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_medical_record')"
                >
                  <router-link to="/electronic-medical-records">
                    <svg
                      width="26"
                      height="27"
                      viewBox="0 0 26 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.4166 4.83341H17.3333C17.3333 4.25878 17.105 3.70768 16.6986 3.30135C16.2923 2.89502 15.7412 2.66675 15.1666 2.66675H10.8333C10.2586 2.66675 9.70752 2.89502 9.30119 3.30135C8.89486 3.70768 8.66658 4.25878 8.66658 4.83341H7.58325C6.7213 4.83341 5.89465 5.17582 5.28515 5.78532C4.67566 6.39481 4.33325 7.22146 4.33325 8.08342V21.0834C4.33325 21.9454 4.67566 22.772 5.28515 23.3815C5.89465 23.991 6.7213 24.3334 7.58325 24.3334H18.4166C19.2785 24.3334 20.1052 23.991 20.7147 23.3815C21.3242 22.772 21.6666 21.9454 21.6666 21.0834V8.08342C21.6666 7.22146 21.3242 6.39481 20.7147 5.78532C20.1052 5.17582 19.2785 4.83341 18.4166 4.83341ZM10.8333 4.83341H15.1666V5.91675V7.00008H10.8333V4.83341ZM19.4999 21.0834C19.4999 21.3707 19.3858 21.6463 19.1826 21.8494C18.9795 22.0526 18.7039 22.1667 18.4166 22.1667H7.58325C7.29593 22.1667 7.02038 22.0526 6.81722 21.8494C6.61406 21.6463 6.49992 21.3707 6.49992 21.0834V8.08342C6.49992 7.7961 6.61406 7.52055 6.81722 7.31738C7.02038 7.11422 7.29593 7.00008 7.58325 7.00008H8.66658C8.66658 7.57472 8.89486 8.12582 9.30119 8.53215C9.70752 8.93848 10.2586 9.16675 10.8333 9.16675H15.1666C15.7412 9.16675 16.2923 8.93848 16.6986 8.53215C17.105 8.12582 17.3333 7.57472 17.3333 7.00008H18.4166C18.7039 7.00008 18.9795 7.11422 19.1826 7.31738C19.3858 7.52055 19.4999 7.7961 19.4999 8.08342V14.5834V21.0834Z"
                        fill="currentColor"
                      />
                      <path
                        d="M10.1965 15.6581H10.5522C10.6626 15.6581 10.7599 15.5857 10.7916 15.48L12.1816 10.8467C12.227 10.6953 12.4455 10.7081 12.473 10.8637L13.8658 18.7561C13.8939 18.9156 14.1198 18.9235 14.159 18.7665L15.0242 15.3058C15.052 15.1945 15.152 15.1165 15.2667 15.1165H17.7799"
                        stroke="currentColor"
                        stroke-linecap="round"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_medical_record") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="3" v-show="$globalClinic && hasHealthRecordsOverview">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_care_plan_overview')"
                >
                  <router-link to="/health-record-overview">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 11H13V9.99997C13 9.73475 12.8947 9.4804 12.7071 9.29286C12.5196 9.10533 12.2652 8.99997 12 8.99997C11.7348 8.99997 11.4805 9.10533 11.2929 9.29286C11.1054 9.4804 11 9.73475 11 9.99997V11H10C9.73482 11 9.48046 11.1053 9.29292 11.2929C9.10539 11.4804 9.00003 11.7348 9.00003 12C9.00003 12.2652 9.10539 12.5195 9.29292 12.7071C9.48046 12.8946 9.73482 13 10 13H11V14C11 14.2652 11.1054 14.5195 11.2929 14.7071C11.4805 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8947 14.5195 13 14.2652 13 14V13H14C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8947 12.5195 15 12.2652 15 12C15 11.7348 14.8947 11.4804 14.7071 11.2929C14.5196 11.1053 14.2652 11 14 11ZM20.16 4.99997C19.0937 3.94467 17.6854 3.30524 16.1891 3.19705C14.6928 3.08886 13.207 3.51904 12 4.40997C10.7277 3.46361 9.14402 3.03448 7.56795 3.20901C5.99188 3.38353 4.54047 4.14875 3.506 5.35055C2.47154 6.55236 1.93085 8.10149 1.99283 9.68598C2.05481 11.2705 2.71485 12.7726 3.84003 13.89L9.84003 19.94C10.4025 20.5018 11.165 20.8173 11.96 20.8173C12.755 20.8173 13.5175 20.5018 14.08 19.94L20.08 13.89C20.671 13.3126 21.142 12.6242 21.466 11.8642C21.79 11.1042 21.9606 10.2877 21.968 9.4616C21.9755 8.63548 21.8196 7.81603 21.5093 7.05035C21.199 6.28467 20.7405 5.58786 20.16 4.99997ZM18.75 12.46L12.75 18.46C12.6571 18.5537 12.5465 18.6281 12.4246 18.6789C12.3027 18.7296 12.172 18.7558 12.04 18.7558C11.908 18.7558 11.7773 18.7296 11.6555 18.6789C11.5336 18.6281 11.423 18.5537 11.33 18.46L5.33003 12.46C4.54579 11.6583 4.10664 10.5814 4.10664 9.45997C4.10664 8.3385 4.54579 7.26162 5.33003 6.45997C6.12919 5.67096 7.207 5.22854 8.33003 5.22854C9.45306 5.22854 10.5309 5.67096 11.33 6.45997C11.423 6.5537 11.5336 6.62809 11.6555 6.67886C11.7773 6.72963 11.908 6.75577 12.04 6.75577C12.172 6.75577 12.3027 6.72963 12.4246 6.67886C12.5465 6.62809 12.6571 6.5537 12.75 6.45997C13.5492 5.67096 14.627 5.22854 15.75 5.22854C16.8731 5.22854 17.9509 5.67096 18.75 6.45997C19.5403 7.26252 19.9832 8.34365 19.9832 9.46997C19.9832 10.5963 19.5403 11.6774 18.75 12.48V12.46Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_care_plan_overview") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="4" v-show="$globalClinic && hasHSSK">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_care_plan')"
                >
                  <router-link to="/doctor/patient-diseases">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.62 21.3101C12.28 21.4301 11.72 21.4301 11.38 21.3101C8.48 20.3201 2 16.1901 2 9.1901C2 6.1001 4.49 3.6001 7.56 3.6001C9.38 3.6001 10.99 4.4801 12 5.8401C13.01 4.4801 14.63 3.6001 16.44 3.6001C19.51 3.6001 22 6.1001 22 9.1901C22 16.1901 15.52 20.3201 12.62 21.3101Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.34595 11.1801H7.96987C8.71987 11.1801 9.55987 11.7501 9.83987 12.4501L10.9799 15.3301C11.2399 15.9801 11.6499 15.9801 11.9099 15.3301L14.1999 9.52011C14.4199 8.96011 14.8299 8.94011 15.1099 9.47011L16.1499 11.4401C16.4599 12.0301 17.2599 12.5101 17.9199 12.5101H21.4999"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_care_plan") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="5" v-show="$globalClinic">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_patient')"
                >
                  <router-link to="/doctor/contact-management">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.3 12.72C12.8336 12.2581 13.2616 11.6869 13.5549 11.045C13.8482 10.4032 14 9.70571 14 9C14 7.67392 13.4732 6.40215 12.5355 5.46447C11.5979 4.52678 10.3261 4 9 4C7.67392 4 6.40215 4.52678 5.46447 5.46447C4.52678 6.40215 4 7.67392 4 9C3.99999 9.70571 4.1518 10.4032 4.44513 11.045C4.73845 11.6869 5.16642 12.2581 5.7 12.72C4.30014 13.3539 3.11247 14.3775 2.27898 15.6685C1.4455 16.9596 1.00147 18.4633 1 20C1 20.2652 1.10536 20.5196 1.29289 20.7071C1.48043 20.8946 1.73478 21 2 21C2.26522 21 2.51957 20.8946 2.70711 20.7071C2.89464 20.5196 3 20.2652 3 20C3 18.4087 3.63214 16.8826 4.75736 15.7574C5.88258 14.6321 7.4087 14 9 14C10.5913 14 12.1174 14.6321 13.2426 15.7574C14.3679 16.8826 15 18.4087 15 20C15 20.2652 15.1054 20.5196 15.2929 20.7071C15.4804 20.8946 15.7348 21 16 21C16.2652 21 16.5196 20.8946 16.7071 20.7071C16.8946 20.5196 17 20.2652 17 20C16.9985 18.4633 16.5545 16.9596 15.721 15.6685C14.8875 14.3775 13.6999 13.3539 12.3 12.72ZM9 12C8.40666 12 7.82664 11.8241 7.33329 11.4944C6.83994 11.1648 6.45542 10.6962 6.22836 10.1481C6.0013 9.59987 5.94189 8.99667 6.05764 8.41473C6.1734 7.83279 6.45912 7.29824 6.87868 6.87868C7.29824 6.45912 7.83279 6.1734 8.41473 6.05764C8.99667 5.94189 9.59987 6.0013 10.1481 6.22836C10.6962 6.45542 11.1648 6.83994 11.4944 7.33329C11.8241 7.82664 12 8.40666 12 9C12 9.79565 11.6839 10.5587 11.1213 11.1213C10.5587 11.6839 9.79565 12 9 12ZM18.74 12.32C19.38 11.5993 19.798 10.7091 19.9438 9.75634C20.0896 8.80362 19.9569 7.82907 19.5618 6.95C19.1666 6.07093 18.5258 5.3248 17.7165 4.80142C16.9071 4.27805 15.9638 3.99974 15 4C14.7348 4 14.4804 4.10536 14.2929 4.29289C14.1054 4.48043 14 4.73478 14 5C14 5.26522 14.1054 5.51957 14.2929 5.70711C14.4804 5.89464 14.7348 6 15 6C15.7956 6 16.5587 6.31607 17.1213 6.87868C17.6839 7.44129 18 8.20435 18 9C17.9986 9.52524 17.8593 10.0409 17.5961 10.4954C17.3328 10.9499 16.9549 11.3274 16.5 11.59C16.3517 11.6755 16.2279 11.7977 16.1404 11.9447C16.0528 12.0918 16.0045 12.2589 16 12.43C15.9958 12.5998 16.0349 12.7678 16.1137 12.9183C16.1924 13.0687 16.3081 13.1967 16.45 13.29L16.84 13.55L16.97 13.62C18.1754 14.1917 19.1923 15.096 19.901 16.2263C20.6096 17.3566 20.9805 18.6659 20.97 20C20.97 20.2652 21.0754 20.5196 21.2629 20.7071C21.4504 20.8946 21.7048 21 21.97 21C22.2352 21 22.4896 20.8946 22.6771 20.7071C22.8646 20.5196 22.97 20.2652 22.97 20C22.9782 18.4654 22.5938 16.9543 21.8535 15.6101C21.1131 14.2659 20.0413 13.1333 18.74 12.32Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_patient") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="100" v-show="$globalClinic && hasReception">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_admission')"
                >
                  <router-link to="/doctor/patient-reception">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.41788 12.718C9.12923 12.718 9.70588 12.1471 9.70588 11.443C9.70588 10.7388 9.12923 10.168 8.41788 10.168C7.70654 10.168 7.12988 10.7388 7.12988 11.443C7.12988 12.1471 7.70654 12.718 8.41788 12.718Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.4 13.051C7.62 13.061 7 13.705 7 14.477V14.836C7 14.919 7.068 14.986 7.152 14.986H9.683C9.70283 14.9861 9.72249 14.9824 9.74086 14.9749C9.75923 14.9674 9.77595 14.9564 9.79007 14.9425C9.80418 14.9286 9.81541 14.912 9.82312 14.8937C9.83083 14.8754 9.83487 14.8558 9.835 14.836V14.454C9.8341 14.2673 9.79614 14.0826 9.72331 13.9107C9.65047 13.7388 9.54423 13.5831 9.41073 13.4526C9.27724 13.3221 9.11915 13.2194 8.94564 13.1504C8.77214 13.0815 8.58667 13.0477 8.4 13.051Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.6799 12.531C12.4498 12.531 13.0739 11.9131 13.0739 11.151C13.0739 10.3888 12.4498 9.771 11.6799 9.771C10.91 9.771 10.2859 10.3888 10.2859 11.151C10.2859 11.9131 10.91 12.531 11.6799 12.531Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.661 12.8922C11.2566 12.8992 10.8711 13.065 10.5877 13.3536C10.3043 13.6422 10.1457 14.0307 10.146 14.4352V14.8352C10.146 14.9192 10.214 14.9862 10.298 14.9862H13.062C13.0819 14.9864 13.1017 14.9827 13.1202 14.9753C13.1387 14.9679 13.1555 14.9569 13.1697 14.943C13.1839 14.9291 13.1953 14.9124 13.203 14.8941C13.2108 14.8758 13.2149 14.8561 13.215 14.8362V14.4112C13.215 13.5662 12.517 12.8812 11.661 12.8922ZM15.243 12.1752C16.125 12.1752 16.84 11.4672 16.84 10.5942C16.84 9.72116 16.125 9.01416 15.243 9.01416C14.361 9.01416 13.646 9.72116 13.646 10.5942C13.646 11.4672 14.361 12.1742 15.243 12.1742V12.1752ZM15.243 12.5882C14.273 12.5882 13.486 13.3672 13.486 14.3282V14.8362C13.486 14.9192 13.554 14.9862 13.638 14.9862H16.848C16.8678 14.9863 16.8875 14.9825 16.9059 14.975C16.9242 14.9676 16.9409 14.9566 16.9551 14.9426C16.9692 14.9287 16.9804 14.9121 16.9881 14.8939C16.9958 14.8756 16.9999 14.856 17 14.8362V14.3272C17 13.3672 16.213 12.5872 15.243 12.5872V12.5882Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6 4C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6ZM6 2H18C19.0609 2 20.0783 2.42143 20.8284 3.17157C21.5786 3.92172 22 4.93913 22 6V18C22 19.0609 21.5786 20.0783 20.8284 20.8284C20.0783 21.5786 19.0609 22 18 22H6C4.93913 22 3.92172 21.5786 3.17157 20.8284C2.42143 20.0783 2 19.0609 2 18V6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2V2Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_admission") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="101" v-show="$globalClinic && hasExamination">
                <div data-toggle="tooltip" data-placement="right" title="Khám/Tư vấn">
                  <router-link to="/doctor/patient-visit">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 15.417V16C9 17.1935 9.47411 18.3381 10.318 19.182C11.1619 20.0259 12.3065 20.5 13.5 20.5C14.6935 20.5 15.8381 20.0259 16.682 19.182C17.5259 18.3381 18 17.1935 18 16V14.33C17.3325 14.0941 16.7699 13.6298 16.4116 13.0192C16.0534 12.4086 15.9225 11.691 16.0422 10.9932C16.1619 10.2954 16.5244 9.66246 17.0656 9.20613C17.6069 8.7498 18.292 8.49951 19 8.49951C19.708 8.49951 20.3931 8.7498 20.9344 9.20613C21.4756 9.66246 21.8381 10.2954 21.9578 10.9932C22.0775 11.691 21.9466 12.4086 21.5884 13.0192C21.2301 13.6298 20.6675 14.0941 20 14.33V16C20 17.7239 19.3152 19.3772 18.0962 20.5962C16.8772 21.8152 15.2239 22.5 13.5 22.5C11.7761 22.5 10.1228 21.8152 8.90381 20.5962C7.68482 19.3772 7 17.7239 7 16V15.417C5.60193 15.1803 4.33281 14.4562 3.4176 13.3732C2.50239 12.2901 2.00018 10.918 2 9.5L2 4.5C2 3.96957 2.21071 3.46086 2.58579 3.08579C2.96086 2.71071 3.46957 2.5 4 2.5H5C5.26522 2.5 5.51957 2.60536 5.70711 2.79289C5.89464 2.98043 6 3.23478 6 3.5C6 3.76522 5.89464 4.01957 5.70711 4.20711C5.51957 4.39464 5.26522 4.5 5 4.5H4V9.5C4 10.5609 4.42143 11.5783 5.17157 12.3284C5.92172 13.0786 6.93913 13.5 8 13.5C9.06087 13.5 10.0783 13.0786 10.8284 12.3284C11.5786 11.5783 12 10.5609 12 9.5V4.5H11C10.7348 4.5 10.4804 4.39464 10.2929 4.20711C10.1054 4.01957 10 3.76522 10 3.5C10 3.23478 10.1054 2.98043 10.2929 2.79289C10.4804 2.60536 10.7348 2.5 11 2.5H12C12.5304 2.5 13.0391 2.71071 13.4142 3.08579C13.7893 3.46086 14 3.96957 14 4.5V9.5C13.9998 10.918 13.4976 12.2901 12.5824 13.3732C11.6672 14.4562 10.3981 15.1803 9 15.417ZM19 12.5C19.2652 12.5 19.5196 12.3946 19.7071 12.2071C19.8946 12.0196 20 11.7652 20 11.5C20 11.2348 19.8946 10.9804 19.7071 10.7929C19.5196 10.6054 19.2652 10.5 19 10.5C18.7348 10.5 18.4804 10.6054 18.2929 10.7929C18.1054 10.9804 18 11.2348 18 11.5C18 11.7652 18.1054 12.0196 18.2929 12.2071C18.4804 12.3946 18.7348 12.5 19 12.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_examination_schedule") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="107" v-show="$globalClinic && hasPayment">
                <div data-toggle="tooltip" data-placement="right" title="Thu ngân">
                  <router-link to="/payment-management">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28 6H4C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8V24C2 24.5304 2.21071 25.0391 2.58579 25.4142C2.96086 25.7893 3.46957 26 4 26H28C28.5304 26 29.0391 25.7893 29.4142 25.4142C29.7893 25.0391 30 24.5304 30 24V8C30 7.46957 29.7893 6.96086 29.4142 6.58579C29.0391 6.21071 28.5304 6 28 6ZM28 8V11H4V8H28ZM28 24H4V13H28V24ZM26 21C26 21.2652 25.8946 21.5196 25.7071 21.7071C25.5196 21.8946 25.2652 22 25 22H21C20.7348 22 20.4804 21.8946 20.2929 21.7071C20.1054 21.5196 20 21.2652 20 21C20 20.7348 20.1054 20.4804 20.2929 20.2929C20.4804 20.1054 20.7348 20 21 20H25C25.2652 20 25.5196 20.1054 25.7071 20.2929C25.8946 20.4804 26 20.7348 26 21ZM18 21C18 21.2652 17.8946 21.5196 17.7071 21.7071C17.5196 21.8946 17.2652 22 17 22H15C14.7348 22 14.4804 21.8946 14.2929 21.7071C14.1054 21.5196 14 21.2652 14 21C14 20.7348 14.1054 20.4804 14.2929 20.2929C14.4804 20.1054 14.7348 20 15 20H17C17.2652 20 17.5196 20.1054 17.7071 20.2929C17.8946 20.4804 18 20.7348 18 21Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_payment") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="103" v-show="$globalClinic && hasBedMgmt">
                <div data-toggle="tooltip" data-placement="right" title="Phòng giường">
                  <router-link to="/room-management">
                    <svg
                      version="1.1"
                      width="24"
                      height="25"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="131 -131 512 512"
                      style="enable-background: new 131 -131 512 512"
                      xml:space="preserve"
                    >
                      <g id="XMLID_2_">
                        <path
                          fill="currentColor"
                          id="XMLID_7_"
                          d="M195.2,157.1h431.9c4.7,0,8.4,1.9,11.2,4.7s4.7,6.5,4.7,11.2v111.7h-64.2v-64.2H195.2v64.2H131V-18.8   c0-4.7,1.9-8.4,4.7-11.2c2.8-2.8,6.5-4.7,11.2-4.7h31.7c4.7,0,8.4,1.9,11.2,4.7c2.8,2.8,4.7,6.5,4.7,11.2v175.9L195.2,157.1   L195.2,157.1z M338.6,77.1c0-17.7-6.5-32.6-18.6-45.6s-27.9-18.6-45.6-18.6s-32.6,6.5-45.6,18.6s-18.6,27.9-18.6,45.6   s6.5,32.6,18.6,45.6c12.1,13,27.9,18.6,45.6,18.6s32.6-6.5,45.6-18.6S338.6,94.7,338.6,77.1z M643,141.3v-15.8   c0-26.1-9.3-49.3-27.9-68c-18.6-18.6-41-27.9-68-27.9H371.2c-4.7,0-8.4,1.9-11.2,4.7s-4.7,6.5-4.7,11.2v95.9H643V141.3z"
                        />
                      </g>
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_room_management") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="102" v-show="$globalClinic && hasSchedule">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_schedule')"
                >
                  <router-link to="/doctor/work-schedules">
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 13.7C11.2176 13.7 11.4302 13.6355 11.6111 13.5146C11.792 13.3937 11.933 13.222 12.0163 13.021C12.0995 12.82 12.1213 12.5988 12.0789 12.3854C12.0364 12.172 11.9317 11.976 11.7778 11.8222C11.624 11.6683 11.428 11.5636 11.2146 11.5211C11.0012 11.4787 10.78 11.5005 10.579 11.5837C10.378 11.667 10.2063 11.808 10.0854 11.9889C9.96451 12.1698 9.9 12.3824 9.9 12.6C9.9 12.8917 10.0159 13.1715 10.2222 13.3778C10.4285 13.5841 10.7083 13.7 11 13.7ZM16.5 13.7C16.7176 13.7 16.9302 13.6355 17.1111 13.5146C17.292 13.3937 17.433 13.222 17.5163 13.021C17.5995 12.82 17.6213 12.5988 17.5789 12.3854C17.5364 12.172 17.4317 11.976 17.2778 11.8222C17.124 11.6683 16.928 11.5636 16.7146 11.5211C16.5012 11.4787 16.28 11.5005 16.0791 11.5837C15.8781 11.667 15.7063 11.808 15.5854 11.9889C15.4645 12.1698 15.4 12.3824 15.4 12.6C15.4 12.8917 15.5159 13.1715 15.7222 13.3778C15.9285 13.5841 16.2083 13.7 16.5 13.7ZM11 18.1C11.2176 18.1 11.4302 18.0355 11.6111 17.9146C11.792 17.7937 11.933 17.622 12.0163 17.421C12.0995 17.22 12.1213 16.9988 12.0789 16.7854C12.0364 16.572 11.9317 16.376 11.7778 16.2222C11.624 16.0683 11.428 15.9636 11.2146 15.9211C11.0012 15.8787 10.78 15.9005 10.579 15.9837C10.378 16.067 10.2063 16.208 10.0854 16.3889C9.96451 16.5698 9.9 16.7824 9.9 17C9.9 17.2917 10.0159 17.5715 10.2222 17.7778C10.4285 17.9841 10.7083 18.1 11 18.1ZM16.5 18.1C16.7176 18.1 16.9302 18.0355 17.1111 17.9146C17.292 17.7937 17.433 17.622 17.5163 17.421C17.5995 17.22 17.6213 16.9988 17.5789 16.7854C17.5364 16.572 17.4317 16.376 17.2778 16.2222C17.124 16.0683 16.928 15.9636 16.7146 15.9211C16.5012 15.8787 16.28 15.9005 16.0791 15.9837C15.8781 16.067 15.7063 16.208 15.5854 16.3889C15.4645 16.5698 15.4 16.7824 15.4 17C15.4 17.2917 15.5159 17.5715 15.7222 17.7778C15.9285 17.9841 16.2083 18.1 16.5 18.1ZM5.5 13.7C5.71756 13.7 5.93023 13.6355 6.11113 13.5146C6.29202 13.3937 6.43301 13.222 6.51627 13.021C6.59952 12.82 6.62131 12.5988 6.57886 12.3854C6.53642 12.172 6.43166 11.976 6.27782 11.8222C6.12398 11.6683 5.92798 11.5636 5.7146 11.5211C5.50122 11.4787 5.28005 11.5005 5.07905 11.5837C4.87805 11.667 4.70625 11.808 4.58538 11.9889C4.46451 12.1698 4.4 12.3824 4.4 12.6C4.4 12.8917 4.51589 13.1715 4.72218 13.3778C4.92847 13.5841 5.20826 13.7 5.5 13.7ZM18.7 2.7H17.6V1.6C17.6 1.30826 17.4841 1.02847 17.2778 0.822183C17.0715 0.615892 16.7917 0.5 16.5 0.5C16.2083 0.5 15.9285 0.615892 15.7222 0.822183C15.5159 1.02847 15.4 1.30826 15.4 1.6V2.7H6.6V1.6C6.6 1.30826 6.48411 1.02847 6.27782 0.822183C6.07153 0.615892 5.79174 0.5 5.5 0.5C5.20826 0.5 4.92847 0.615892 4.72218 0.822183C4.51589 1.02847 4.4 1.30826 4.4 1.6V2.7H3.3C2.42479 2.7 1.58542 3.04768 0.966548 3.66655C0.347678 4.28542 0 5.12479 0 6V19.2C0 20.0752 0.347678 20.9146 0.966548 21.5335C1.58542 22.1523 2.42479 22.5 3.3 22.5H18.7C19.5752 22.5 20.4146 22.1523 21.0335 21.5335C21.6523 20.9146 22 20.0752 22 19.2V6C22 5.12479 21.6523 4.28542 21.0335 3.66655C20.4146 3.04768 19.5752 2.7 18.7 2.7V2.7ZM19.8 19.2C19.8 19.4917 19.6841 19.7715 19.4778 19.9778C19.2715 20.1841 18.9917 20.3 18.7 20.3H3.3C3.00826 20.3 2.72847 20.1841 2.52218 19.9778C2.31589 19.7715 2.2 19.4917 2.2 19.2V9.3H19.8V19.2ZM19.8 7.1H2.2V6C2.2 5.70826 2.31589 5.42847 2.52218 5.22218C2.72847 5.01589 3.00826 4.9 3.3 4.9H18.7C18.9917 4.9 19.2715 5.01589 19.4778 5.22218C19.6841 5.42847 19.8 5.70826 19.8 6V7.1ZM5.5 18.1C5.71756 18.1 5.93023 18.0355 6.11113 17.9146C6.29202 17.7937 6.43301 17.622 6.51627 17.421C6.59952 17.22 6.62131 16.9988 6.57886 16.7854C6.53642 16.572 6.43166 16.376 6.27782 16.2222C6.12398 16.0683 5.92798 15.9636 5.7146 15.9211C5.50122 15.8787 5.28005 15.9005 5.07905 15.9837C4.87805 16.067 4.70625 16.208 4.58538 16.3889C4.46451 16.5698 4.4 16.7824 4.4 17C4.4 17.2917 4.51589 17.5715 4.72218 17.7778C4.92847 17.9841 5.20826 18.1 5.5 18.1Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_schedule") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item v-show="$globalClinic || (!$globalClinic && !$globalOrg)" index="201">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_consultation')"
                >
                  <router-link to="/hoi-chan">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.05 2.51001C10.5 2.51001 9.22998 3.77001 9.22998 5.33001C9.22998 6.89001 10.49 8.15001 12.05 8.15001C13.61 8.15001 14.87 6.89001 14.87 5.33001C14.87 3.77001 13.61 2.51001 12.05 2.51001Z"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M5.04998 14.37C3.49998 14.37 2.22998 15.63 2.22998 17.19C2.22998 18.75 3.48998 20.01 5.04998 20.01C6.60998 20.01 7.86998 18.75 7.86998 17.19C7.86998 15.63 6.59998 14.37 5.04998 14.37Z"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M18.9499 14.37C17.3999 14.37 16.1299 15.63 16.1299 17.19C16.1299 18.75 17.3899 20.01 18.9499 20.01C20.5099 20.01 21.7699 18.75 21.7699 17.19C21.7699 15.63 20.5099 14.37 18.9499 14.37Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M17.6255 6.47439C17.1946 6.12895 16.5652 6.19825 16.2198 6.62917C15.8743 7.06009 15.9436 7.68945 16.3745 8.03489L17.6255 6.47439ZM19.748 11.5L18.7795 11.7493L19.748 11.5ZM18.9053 12.345C18.9957 12.8898 19.5106 13.2583 20.0555 13.1679C20.6003 13.0775 20.9687 12.5626 20.8784 12.0178L18.9053 12.345ZM16.3745 8.03489C17.539 8.96836 18.3974 10.2646 18.7795 11.7493L20.7164 11.2508C20.2238 9.3369 19.119 7.67162 17.6255 6.47439L16.3745 8.03489ZM18.7795 11.7493C18.8298 11.9446 18.8719 12.1433 18.9053 12.345L20.8784 12.0178C20.8353 11.7582 20.7812 11.5024 20.7164 11.2508L18.7795 11.7493Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.0756 21.3908C15.5903 21.1903 15.8449 20.6106 15.6445 20.096C15.444 19.5814 14.8643 19.3267 14.3497 19.5272L15.0756 21.3908ZM9.66208 20.7161L9.93043 19.7528L9.66208 20.7161ZM9.35163 19.5638C8.8346 19.3697 8.25807 19.6314 8.0639 20.1484C7.86973 20.6655 8.13146 21.242 8.64849 21.4362L9.35163 19.5638ZM14.3497 19.5272C12.959 20.0689 11.4073 20.1642 9.93043 19.7528L9.39372 21.6794C11.2975 22.2097 13.2921 22.0855 15.0756 21.3908L14.3497 19.5272ZM9.93043 19.7528C9.73613 19.6986 9.54302 19.6357 9.35163 19.5638L8.64849 21.4362C8.89477 21.5286 9.14341 21.6097 9.39372 21.6794L9.93043 19.7528Z"
                        fill="currentColor"
                      />
                      <path
                        d="M6.37453 6.47439C6.80545 6.12895 7.43481 6.19825 7.78025 6.62917C8.12569 7.06009 8.05639 7.68945 7.62547 8.03489L6.37453 6.47439ZM4.25204 11.5L5.22047 11.7493L4.25204 11.5ZM5.09468 12.345C5.00432 12.8898 4.48939 13.2583 3.94455 13.1679C3.3997 13.0775 3.03127 12.5626 3.12163 12.0178L5.09468 12.345ZM7.62547 8.03489C6.46101 8.96836 5.6026 10.2646 5.22047 11.7493L3.2836 11.2508C3.77619 9.3369 4.88103 7.67162 6.37453 6.47439L7.62547 8.03489ZM5.22047 11.7493C5.1702 11.9446 5.12813 12.1433 5.09468 12.345L3.12163 12.0178C3.16468 11.7582 3.21883 11.5024 3.2836 11.2508L5.22047 11.7493Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_consultation") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item v-show="$globalClinic || (!$globalClinic && !$globalOrg)" index="202">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_meeting')"
                >
                  <router-link to="/meeting">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.8163 15.6205C15.8163 17.6135 14.4583 19.0215 12.2863 19.0215H6.06929C3.89929 19.0215 2.55029 17.6135 2.55029 15.6205V8.66049C2.55029 6.66849 3.89929 5.25049 6.08029 5.25049H12.2863C14.4583 5.25049 15.8163 6.66849 15.8163 8.66049V15.6205Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 11.5823L20.097 8.22827C20.747 7.69327 21.734 8.15827 21.734 9.00527V15.8773C21.734 16.7253 20.747 17.1883 20.097 16.6543L16 13.3003"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_meeting") }}</span>
                  </router-link>
                </div>
              </el-menu-item>

              <el-menu-item index="9">
                <div data-toggle="tooltip" :title="$t('side_menu.lbl_chat')">
                  <a :href="goToConversation" class="relative" target="_blank">
                    <span class="noti-count" v-if="$chatClientCount > 0">{{ $chatClientCount }}</span>
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 8.5H18V5.5C18 4.70435 17.6839 3.94129 17.1213 3.37868C16.5587 2.81607 15.7956 2.5 15 2.5H5C4.20435 2.5 3.44129 2.81607 2.87868 3.37868C2.31607 3.94129 2 4.70435 2 5.5V17.5C2.00099 17.6974 2.06039 17.8901 2.17072 18.0539C2.28105 18.2176 2.43738 18.345 2.62 18.42C2.73868 18.476 2.86882 18.5034 3 18.5C3.13161 18.5008 3.26207 18.4755 3.38391 18.4258C3.50574 18.376 3.61656 18.3027 3.71 18.21L6.52 15.39H8V16.83C8 17.6256 8.31607 18.3887 8.87868 18.9513C9.44129 19.5139 10.2044 19.83 11 19.83H17.92L20.29 22.21C20.3834 22.3027 20.4943 22.376 20.6161 22.4258C20.7379 22.4755 20.8684 22.5008 21 22.5C21.1312 22.5034 21.2613 22.476 21.38 22.42C21.5626 22.345 21.7189 22.2176 21.8293 22.0539C21.9396 21.8901 21.999 21.6974 22 21.5V11.5C22 10.7044 21.6839 9.94129 21.1213 9.37868C20.5587 8.81607 19.7956 8.5 19 8.5ZM8 11.5V13.39H6.11C5.97839 13.3892 5.84793 13.4145 5.72609 13.4642C5.60426 13.514 5.49344 13.5873 5.4 13.68L4 15.09V5.5C4 5.23478 4.10536 4.98043 4.29289 4.79289C4.48043 4.60536 4.73478 4.5 5 4.5H15C15.2652 4.5 15.5196 4.60536 15.7071 4.79289C15.8946 4.98043 16 5.23478 16 5.5V8.5H11C10.2044 8.5 9.44129 8.81607 8.87868 9.37868C8.31607 9.94129 8 10.7044 8 11.5ZM20 19.09L19 18.09C18.9074 17.9955 18.7969 17.9203 18.6751 17.8688C18.5532 17.8173 18.4223 17.7906 18.29 17.79H11C10.7348 17.79 10.4804 17.6846 10.2929 17.4971C10.1054 17.3096 10 17.0552 10 16.79V11.5C10 11.2348 10.1054 10.9804 10.2929 10.7929C10.4804 10.6054 10.7348 10.5 11 10.5H19C19.2652 10.5 19.5196 10.6054 19.7071 10.7929C19.8946 10.9804 20 11.2348 20 11.5V19.09Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_chat") }}</span>
                  </a>
                </div>
              </el-menu-item>
              <el-menu-item index="104">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_doctor_circle')"
                >
                  <router-link to="/circle" class="relative">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.87868 14.6213C11.0503 15.7929 12.9497 15.7929 14.1213 14.6213C15.2929 13.4497 15.2929 11.5502 14.1213 10.3786C12.9497 9.20707 11.0503 9.20707 9.87868 10.3786C8.70711 11.5502 8.70711 13.4497 9.87868 14.6213Z"
                        fill="currentColor"
                      />
                      <circle cx="3.99974" cy="12.4997" r="2.99974" fill="currentColor" />
                      <path
                        d="M15 4.5C15 6.15685 13.6569 7.5 12 7.5C10.3431 7.5 9 6.15685 9 4.5C9 2.84315 10.3431 1.5 12 1.5C13.6569 1.5 15 2.84315 15 4.5Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15 20.5C15 22.1569 13.6569 23.5 12 23.5C10.3431 23.5 9 22.1569 9 20.5C9 18.8431 10.3431 17.5 12 17.5C13.6569 17.5 15 18.8431 15 20.5Z"
                        fill="currentColor"
                      />
                      <circle cx="19.9997" cy="12.5002" r="2.99974" fill="currentColor" />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_doctor_circle") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item v-show="hasEcomMarketplace" index="105">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_ecom_marketplace')"
                >
                  <a :href="linkMarketplace" target="_blank" class="relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 48 48"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        x
                        d="M9.263 6c-.378 0-.715.262-.845.656L6.11 13.667a2.2 2.2 0 0 0-.11.687v2.789C6 18.72 7.151 20 8.571 20c1.42 0 2.572-1.28 2.572-2.857c0 1.578 1.151 2.857 2.571 2.857c1.42 0 2.572-1.28 2.572-2.857c0 1.578 1.151 2.857 2.571 2.857c1.42 0 2.57-1.278 2.572-2.855C21.429 18.722 22.58 20 24 20c1.42 0 2.571-1.28 2.571-2.857c0 1.578 1.152 2.857 2.572 2.857c1.42 0 2.57-1.278 2.571-2.855c.001 1.577 1.152 2.855 2.572 2.855c1.42 0 2.571-1.28 2.571-2.857c0 1.578 1.151 2.857 2.572 2.857C40.849 20 42 18.72 42 17.143v-2.789a2.2 2.2 0 0 0-.11-.687l-2.308-7.01c-.13-.395-.467-.657-.845-.657z"
                        clip-rule="evenodd"
                      />
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M10 21.23V29H7.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h33a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H38v-7.77a3.916 3.916 0 0 1-1.143-.703a3.953 3.953 0 0 1-.857.576V29H12v-7.897a3.953 3.953 0 0 1-.857-.576c-.336.295-.72.535-1.143.703m26-1.957c.085-.085.165-.176.24-.273H36zM37.474 19a2.75 2.75 0 0 0 .526.519V19zM10 19.519a2.63 2.63 0 0 0 .526-.519H10zM11.76 19H12v.273a2.766 2.766 0 0 1-.24-.273M8.5 33a.5.5 0 0 0-.5.5V41a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-7.5a.5.5 0 0 0-.5-.5z"
                        clip-rule="evenodd"
                      />
                      <path
                        fill="currentColor"
                        d="M14 26.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
                      />
                      <path
                        fill="currentColor"
                        d="M16 27.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm8 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_ecom_marketplace") }}</span>
                  </a>
                </div>
              </el-menu-item>
              <el-menu-item v-if="hasManageEcomMK" index="106">
                <div data-toggle="tooltip" :title="$t('Quản lý chợ')">
                  <a :href="linkMarketplaceWarehouse" target="_blank" class="relative">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="currentColor"
                        d="M4 19h2v-8h12v8h2V8.35l-8-3.2l-8 3.2zm-2 2V7l10-4l10 4v14h-6v-8H8v8zm7 0v-2h2v2zm2-3v-2h2v2zm2 3v-2h2v2zM6 11h12z"
                      />
                    </svg>
                    <span class="fw-500 ml-6">{{ $t("Quản lý chợ") }}</span>
                  </a>
                </div>
              </el-menu-item>
              <el-menu-item v-show="hasSign && isDoctor" index="16">
                <div
                  class="ml-0.5"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('Ký điện tử')"
                >
                  <router-link to="/digital-signature">
                    <signature-icon></signature-icon>
                    <span class="fw-500 ml-6">{{ $t("Ký điện tử") }}</span>
                  </router-link>
                </div>
              </el-menu-item>
              <el-menu-item index="11" v-if="$clinicId">
                <div
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="$t('side_menu.lbl_ws_setting')[$orgModel]"
                >
                  <router-link to="/ws-mgmt">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.32 10.05L19.43 9.42L20.32 7.64C20.4102 7.45369 20.4404 7.24397 20.4064 7.03978C20.3723 6.83558 20.2758 6.64699 20.13 6.5L18 4.37C17.8522 4.22209 17.6618 4.12421 17.4555 4.09013C17.2493 4.05605 17.0375 4.08748 16.85 4.18L15.07 5.07L14.44 3.18C14.3735 2.983 14.2472 2.81163 14.0787 2.68975C13.9102 2.56787 13.7079 2.50155 13.5 2.5H10.5C10.2904 2.49946 10.0858 2.56482 9.91537 2.68685C9.7449 2.80887 9.61709 2.98138 9.55 3.18L8.92 5.07L7.14 4.18C6.95369 4.08978 6.74397 4.05961 6.53978 4.09364C6.33558 4.12767 6.14699 4.22423 6 4.37L3.87 6.5C3.72209 6.64777 3.62421 6.83818 3.59013 7.04446C3.55605 7.25074 3.58748 7.46251 3.68 7.65L4.57 9.43L2.68 10.06C2.483 10.1265 2.31163 10.2528 2.18975 10.4213C2.06787 10.5898 2.00155 10.7921 2 11V14C1.99946 14.2096 2.06482 14.4142 2.18685 14.5846C2.30887 14.7551 2.48138 14.8829 2.68 14.95L4.57 15.58L3.68 17.36C3.58978 17.5463 3.55961 17.756 3.59364 17.9602C3.62767 18.1644 3.72423 18.353 3.87 18.5L6 20.63C6.14777 20.7779 6.33818 20.8758 6.54446 20.9099C6.75074 20.944 6.96251 20.9125 7.15 20.82L8.93 19.93L9.56 21.82C9.62709 22.0186 9.7549 22.1911 9.92537 22.3132C10.0958 22.4352 10.3004 22.5005 10.51 22.5H13.51C13.7196 22.5005 13.9242 22.4352 14.0946 22.3132C14.2651 22.1911 14.3929 22.0186 14.46 21.82L15.09 19.93L16.87 20.82C17.0551 20.9079 17.2628 20.9369 17.4649 20.9029C17.667 20.8689 17.8538 20.7737 18 20.63L20.13 18.5C20.2779 18.3522 20.3758 18.1618 20.4099 17.9555C20.444 17.7493 20.4125 17.5375 20.32 17.35L19.43 15.57L21.32 14.94C21.517 14.8735 21.6884 14.7472 21.8103 14.5787C21.9321 14.4102 21.9985 14.2079 22 14V11C22.0005 10.7904 21.9352 10.5858 21.8132 10.4154C21.6911 10.2449 21.5186 10.1171 21.32 10.05ZM20 13.28L18.8 13.68C18.5241 13.7695 18.2709 13.918 18.0581 14.1151C17.8452 14.3122 17.6778 14.5533 17.5675 14.8216C17.4571 15.0899 17.4064 15.379 17.419 15.6688C17.4315 15.9586 17.5069 16.2422 17.64 16.5L18.21 17.64L17.11 18.74L16 18.14C15.7436 18.0122 15.4627 17.9411 15.1763 17.9313C14.89 17.9215 14.6049 17.9734 14.3403 18.0834C14.0758 18.1934 13.8379 18.3589 13.6429 18.5688C13.4479 18.7787 13.3003 19.0281 13.21 19.3L12.81 20.5H11.22L10.82 19.3C10.7305 19.0241 10.582 18.7709 10.3849 18.5581C10.1878 18.3452 9.94671 18.1778 9.67842 18.0675C9.41014 17.9571 9.12105 17.9064 8.83123 17.919C8.5414 17.9315 8.25777 18.0069 8 18.14L6.86 18.71L5.76 17.61L6.36 16.5C6.4931 16.2422 6.56852 15.9586 6.58105 15.6688C6.59358 15.379 6.5429 15.0899 6.43254 14.8216C6.32218 14.5533 6.15478 14.3122 5.94195 14.1151C5.72912 13.918 5.47595 13.7695 5.2 13.68L4 13.28V11.72L5.2 11.32C5.47595 11.2305 5.72912 11.082 5.94195 10.8849C6.15478 10.6878 6.32218 10.4467 6.43254 10.1784C6.5429 9.91014 6.59358 9.62105 6.58105 9.33123C6.56852 9.0414 6.4931 8.75777 6.36 8.5L5.79 7.39L6.89 6.29L8 6.86C8.25777 6.9931 8.5414 7.06852 8.83123 7.08105C9.12105 7.09358 9.41014 7.0429 9.67842 6.93254C9.94671 6.82218 10.1878 6.65478 10.3849 6.44195C10.582 6.22912 10.7305 5.97595 10.82 5.7L11.22 4.5H12.78L13.18 5.7C13.2695 5.97595 13.418 6.22912 13.6151 6.44195C13.8122 6.65478 14.0533 6.82218 14.3216 6.93254C14.5899 7.0429 14.879 7.09358 15.1688 7.08105C15.4586 7.06852 15.7422 6.9931 16 6.86L17.14 6.29L18.24 7.39L17.64 8.5C17.5122 8.75645 17.4411 9.03735 17.4313 9.32369C17.4215 9.61003 17.4734 9.89513 17.5834 10.1597C17.6934 10.4242 17.8589 10.6621 18.0688 10.8571C18.2787 11.0521 18.5281 11.1997 18.8 11.29L20 11.69V13.28ZM12 8.5C11.2089 8.5 10.4355 8.7346 9.77772 9.17413C9.11993 9.61365 8.60724 10.2384 8.30448 10.9693C8.00173 11.7002 7.92252 12.5044 8.07686 13.2804C8.2312 14.0563 8.61217 14.769 9.17158 15.3284C9.73099 15.8878 10.4437 16.2688 11.2196 16.4231C11.9956 16.5775 12.7998 16.4983 13.5307 16.1955C14.2616 15.8928 14.8864 15.3801 15.3259 14.7223C15.7654 14.0645 16 13.2911 16 12.5C16 11.4391 15.5786 10.4217 14.8284 9.67158C14.0783 8.92143 13.0609 8.5 12 8.5ZM12 14.5C11.6044 14.5 11.2178 14.3827 10.8889 14.1629C10.56 13.9432 10.3036 13.6308 10.1522 13.2654C10.0009 12.8999 9.96126 12.4978 10.0384 12.1098C10.1156 11.7219 10.3061 11.3655 10.5858 11.0858C10.8655 10.8061 11.2219 10.6156 11.6098 10.5384C11.9978 10.4613 12.3999 10.5009 12.7654 10.6522C13.1308 10.8036 13.4432 11.06 13.6629 11.3889C13.8827 11.7178 14 12.1044 14 12.5C14 13.0304 13.7893 13.5391 13.4142 13.9142C13.0391 14.2893 12.5304 14.5 12 14.5Z"
                        fill="currentColor"
                      />
                    </svg>

                    <span class="fw-500 ml-6">{{ $t("side_menu.lbl_ws_setting")[$orgModel] }}</span>
                  </router-link>
                </div>
              </el-menu-item>
            </div>

            <!-- <el-menu-item v-show="isDoctor" index="16">
              <div
                class="ml-0.5"
                data-toggle="tooltip"
                data-placement="right"
                :title="$t('Ký điện tử')"
              >
                <router-link to="/digital-signature">
                  <signature-icon></signature-icon>
                  <span class="fw-500 ml-6">{{$t("Ký điện tử") }}</span>
                </router-link>
              </div>
            </el-menu-item>-->
            <el-menu-item v-show="isDoctor" index="12">
              <div
                class="ml-0.5"
                data-toggle="tooltip"
                data-placement="right"
                :title="$t('side_menu.lbl_individual')"
              >
                <router-link to="/doctor/setting">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.98101 0.510345C8.04148 0.51403 6.14489 1.08166 4.52223 2.14408C2.89958 3.20651 1.6209 4.71789 0.841947 6.49411C0.0629925 8.27034 -0.182618 10.2348 0.135032 12.1481C0.452682 14.0614 1.31988 15.8411 2.63101 17.2703C3.56743 18.2854 4.70395 19.0955 5.96894 19.6496C7.23394 20.2036 8.59999 20.4897 9.98101 20.4897C11.362 20.4897 12.7281 20.2036 13.9931 19.6496C15.2581 19.0955 16.3946 18.2854 17.331 17.2703C18.6421 15.8411 19.5093 14.0614 19.827 12.1481C20.1446 10.2348 19.899 8.27034 19.1201 6.49411C18.3411 4.71789 17.0624 3.20651 15.4398 2.14408C13.8171 1.08166 11.9205 0.51403 9.98101 0.510345ZM9.98101 18.5103C7.90947 18.5072 5.91992 17.7006 4.43101 16.2603C4.88305 15.1599 5.65204 14.2186 6.64026 13.5562C7.62848 12.8938 8.79132 12.5401 9.98101 12.5401C11.1707 12.5401 12.3335 12.8938 13.3218 13.5562C14.31 14.2186 15.079 15.1599 15.531 16.2603C14.0421 17.7006 12.0525 18.5072 9.98101 18.5103ZM7.98101 8.51035C7.98101 8.11478 8.0983 7.7281 8.31807 7.39921C8.53783 7.07031 8.85019 6.81396 9.21564 6.66259C9.58109 6.51121 9.98322 6.4716 10.3712 6.54877C10.7591 6.62595 11.1155 6.81643 11.3952 7.09613C11.6749 7.37584 11.8654 7.7322 11.9426 8.12016C12.0197 8.50813 11.9801 8.91026 11.8288 9.27571C11.6774 9.64116 11.421 9.95352 11.0921 10.1733C10.7632 10.393 10.3766 10.5103 9.98101 10.5103C9.45057 10.5103 8.94186 10.2996 8.56679 9.92456C8.19172 9.54949 7.98101 9.04078 7.98101 8.51035ZM16.891 14.5103C15.9975 12.9821 14.6224 11.7934 12.981 11.1303C13.4902 10.553 13.8219 9.841 13.9365 9.07978C14.051 8.31856 13.9435 7.54046 13.6268 6.83884C13.31 6.13723 12.7976 5.5419 12.1509 5.12431C11.5042 4.70672 10.7508 4.48459 9.98101 4.48459C9.21122 4.48459 8.45778 4.70672 7.8111 5.12431C7.16442 5.5419 6.65198 6.13723 6.33526 6.83884C6.01853 7.54046 5.91099 8.31856 6.02554 9.07978C6.14008 9.841 6.47184 10.553 6.98101 11.1303C5.3396 11.7934 3.96447 12.9821 3.07101 14.5103C2.35895 13.2974 1.98273 11.9168 1.98101 10.5103C1.98101 8.38861 2.82386 6.35378 4.32415 4.85349C5.82444 3.3532 7.85927 2.51035 9.98101 2.51035C12.1027 2.51035 14.1376 3.3532 15.6379 4.85349C17.1382 6.35378 17.981 8.38861 17.981 10.5103C17.9793 11.9168 17.6031 13.2974 16.891 14.5103Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("side_menu.lbl_individual") }}</span>
                </router-link>
              </div>
            </el-menu-item>
            <el-menu-item index="13" @click="handleOpenHelpDocument">
              <div data-toggle="tooltip" :title="$t('side_menu.lbl_help')">
                <router-link to="/" class="relative">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.29 15.79C11.247 15.8375 11.2069 15.8876 11.17 15.94C11.1322 15.9957 11.1019 16.0563 11.08 16.12C11.0512 16.1767 11.031 16.2374 11.02 16.3C11.0151 16.3666 11.0151 16.4334 11.02 16.5C11.0166 16.6312 11.044 16.7613 11.1 16.88C11.1449 17.0041 11.2166 17.1168 11.3099 17.2101C11.4032 17.3034 11.5159 17.3751 11.64 17.42C11.7597 17.4729 11.8891 17.5002 12.02 17.5002C12.1509 17.5002 12.2803 17.4729 12.4 17.42C12.5241 17.3751 12.6368 17.3034 12.7301 17.2101C12.8234 17.1168 12.8951 17.0041 12.94 16.88C12.9844 16.7584 13.0048 16.6294 13 16.5C13.0008 16.3684 12.9755 16.2379 12.9258 16.1161C12.876 15.9943 12.8027 15.8834 12.71 15.79C12.617 15.6963 12.5064 15.6219 12.3846 15.5711C12.2627 15.5203 12.132 15.4942 12 15.4942C11.868 15.4942 11.7373 15.5203 11.6154 15.5711C11.4936 15.6219 11.383 15.6963 11.29 15.79ZM12 2.5C10.0222 2.5 8.08879 3.08649 6.4443 4.1853C4.79981 5.28412 3.51809 6.8459 2.76121 8.67317C2.00433 10.5004 1.8063 12.5111 2.19215 14.4509C2.578 16.3907 3.53041 18.1725 4.92894 19.5711C6.32746 20.9696 8.10929 21.922 10.0491 22.3079C11.9889 22.6937 13.9996 22.4957 15.8268 21.7388C17.6541 20.9819 19.2159 19.7002 20.3147 18.0557C21.4135 16.4112 22 14.4778 22 12.5C22 11.1868 21.7413 9.88642 21.2388 8.67317C20.7363 7.45991 19.9997 6.35752 19.0711 5.42893C18.1425 4.50035 17.0401 3.76375 15.8268 3.2612C14.6136 2.75866 13.3132 2.5 12 2.5ZM12 20.5C10.4178 20.5 8.87104 20.0308 7.55544 19.1518C6.23985 18.2727 5.21447 17.0233 4.60897 15.5615C4.00347 14.0997 3.84504 12.4911 4.15372 10.9393C4.4624 9.38743 5.22433 7.96197 6.34315 6.84315C7.46197 5.72433 8.88743 4.9624 10.4393 4.65372C11.9911 4.34504 13.5997 4.50346 15.0615 5.10896C16.5233 5.71447 17.7727 6.73984 18.6518 8.05544C19.5308 9.37103 20 10.9177 20 12.5C20 14.6217 19.1572 16.6566 17.6569 18.1569C16.1566 19.6571 14.1217 20.5 12 20.5ZM12 7.5C11.4731 7.49966 10.9553 7.63812 10.4989 7.90144C10.0425 8.16476 9.66347 8.54366 9.4 9C9.32765 9.11382 9.27907 9.2411 9.25718 9.37418C9.23529 9.50726 9.24055 9.64339 9.27263 9.77439C9.30472 9.90538 9.36297 10.0285 9.44389 10.1364C9.52481 10.2443 9.62671 10.3348 9.74348 10.4022C9.86024 10.4697 9.98945 10.5129 10.1233 10.5292C10.2572 10.5454 10.393 10.5345 10.5225 10.4969C10.6521 10.4593 10.7727 10.3959 10.8771 10.3105C10.9814 10.2251 11.0675 10.1195 11.13 10C11.2181 9.8474 11.345 9.72078 11.4978 9.63298C11.6505 9.54518 11.8238 9.4993 12 9.5C12.2652 9.5 12.5196 9.60536 12.7071 9.79289C12.8946 9.98043 13 10.2348 13 10.5C13 10.7652 12.8946 11.0196 12.7071 11.2071C12.5196 11.3946 12.2652 11.5 12 11.5C11.7348 11.5 11.4804 11.6054 11.2929 11.7929C11.1054 11.9804 11 12.2348 11 12.5V13.5C11 13.7652 11.1054 14.0196 11.2929 14.2071C11.4804 14.3946 11.7348 14.5 12 14.5C12.2652 14.5 12.5196 14.3946 12.7071 14.2071C12.8946 14.0196 13 13.7652 13 13.5V13.32C13.6614 13.08 14.2174 12.6152 14.5708 12.0069C14.9242 11.3985 15.0525 10.6853 14.9334 9.99189C14.8143 9.29849 14.4552 8.66902 13.919 8.21352C13.3828 7.75801 12.7035 7.50546 12 7.5Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span class="fw-500 ml-6">{{ $t("side_menu.lbl_help") }}</span>
                </router-link>
              </div>
            </el-menu-item>
            <el-menu-item index="14" @click="onLogout">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.8125 12.5218H3.77148"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.8848 9.6058L15.8128 12.5218L12.8848 15.4378"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.50439 7.889V6.956C8.50439 4.921 10.1534 3.272 12.1894 3.272H17.0734C19.1034 3.272 20.7484 4.917 20.7484 6.947V18.087C20.7484 20.122 19.0984 21.772 17.0634 21.772H12.1784C10.1494 21.772 8.50439 20.126 8.50439 18.097V17.155"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span class="fw-500 ml-6">{{ $t("side_menu.lbl_logout") }}</span>
            </el-menu-item>
          </el-menu>
        </div>

        <div v-show="isAdmin">
          <div
            class="sb-link"
            :class="isRouteNames(['kycPage']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['kycPage']))"
            data-toggle="tooltip"
            data-placement="right"
            title="operation"
          >
            <router-link to="/admin/operation">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      :stroke="active ? 'white' : '#667085'"
                      d="M10.9999 6.50189C10.2088 6.50189 9.43546 6.73649 8.77766 7.17601C8.11986 7.61554 7.60717 8.24025 7.30442 8.97116C7.00167 9.70206 6.92246 10.5063 7.0768 11.2823C7.23114 12.0582 7.6121 12.7709 8.17151 13.3303C8.73092 13.8897 9.44365 14.2707 10.2196 14.425C10.9955 14.5794 11.7998 14.5002 12.5307 14.1974C13.2616 13.8947 13.8863 13.382 14.3258 12.7242C14.7653 12.0664 14.9999 11.293 14.9999 10.5019C14.9999 9.44103 14.5785 8.42361 13.8284 7.67346C13.0782 6.92332 12.0608 6.50189 10.9999 6.50189V6.50189ZM10.9999 12.5019C10.6044 12.5019 10.2177 12.3846 9.8888 12.1648C9.5599 11.9451 9.30355 11.6327 9.15218 11.2673C9.0008 10.9018 8.9612 10.4997 9.03837 10.1117C9.11554 9.72375 9.30602 9.36738 9.58573 9.08768C9.86543 8.80797 10.2218 8.61749 10.6098 8.54032C10.9977 8.46315 11.3999 8.50276 11.7653 8.65413C12.1308 8.80551 12.4431 9.06185 12.6629 9.39075C12.8826 9.71965 12.9999 10.1063 12.9999 10.5019C12.9999 11.0323 12.7892 11.541 12.4142 11.9161C12.0391 12.2912 11.5304 12.5019 10.9999 12.5019ZM20.7099 9.79189L18.3599 7.50189V4.14189C18.3599 3.87668 18.2546 3.62232 18.067 3.43479C17.8795 3.24725 17.6252 3.14189 17.3599 3.14189H14.0499L11.7099 0.791892C11.617 0.698164 11.5064 0.623769 11.3845 0.573001C11.2627 0.522232 11.132 0.496094 10.9999 0.496094C10.8679 0.496094 10.7372 0.522232 10.6154 0.573001C10.4935 0.623769 10.3829 0.698164 10.2899 0.791892L7.99994 3.14189H4.63994C4.37472 3.14189 4.12037 3.24725 3.93283 3.43479C3.7453 3.62232 3.63994 3.87668 3.63994 4.14189V7.50189L1.28994 9.79189C1.19621 9.88486 1.12182 9.99546 1.07105 10.1173C1.02028 10.2392 0.994141 10.3699 0.994141 10.5019C0.994141 10.6339 1.02028 10.7646 1.07105 10.8865C1.12182 11.0083 1.19621 11.1189 1.28994 11.2119L3.63994 13.5519V16.8619C3.63994 17.1271 3.7453 17.3815 3.93283 17.569C4.12037 17.7565 4.37472 17.8619 4.63994 17.8619H7.99994L10.3399 20.2119C10.4329 20.3056 10.5435 20.38 10.6654 20.4308C10.7872 20.4816 10.9179 20.5077 11.0499 20.5077C11.182 20.5077 11.3127 20.4816 11.4345 20.4308C11.5564 20.38 11.667 20.3056 11.7599 20.2119L14.0999 17.8619H17.4099C17.6752 17.8619 17.9295 17.7565 18.117 17.569C18.3046 17.3815 18.4099 17.1271 18.4099 16.8619V13.5519L20.7599 11.2119C20.8505 11.1157 20.921 11.0025 20.9676 10.8788C21.0141 10.7552 21.0356 10.6235 21.031 10.4915C21.0263 10.3594 20.9956 10.2296 20.9405 10.1096C20.8854 9.98948 20.807 9.88151 20.7099 9.79189ZM16.6599 12.4319C16.5655 12.5245 16.4903 12.635 16.4388 12.7568C16.3873 12.8787 16.3605 13.0096 16.3599 13.1419V15.8619H13.6399C13.5076 15.8624 13.3767 15.8892 13.2549 15.9407C13.133 15.9922 13.0226 16.0674 12.9299 16.1619L10.9999 18.0919L9.06994 16.1619C8.97732 16.0674 8.86688 15.9922 8.745 15.9407C8.62313 15.8892 8.49225 15.8624 8.35994 15.8619H5.63994V13.1419C5.63939 13.0096 5.61259 12.8787 5.56109 12.7568C5.5096 12.635 5.43443 12.5245 5.33994 12.4319L3.40994 10.5019L5.33994 8.57189C5.43443 8.47928 5.5096 8.36883 5.56109 8.24696C5.61259 8.12508 5.63939 7.9942 5.63994 7.86189V5.14189H8.35994C8.49225 5.14134 8.62313 5.11454 8.745 5.06305C8.86688 5.01155 8.97732 4.93638 9.06994 4.84189L10.9999 2.91189L12.9299 4.84189C13.0226 4.93638 13.133 5.01155 13.2549 5.06305C13.3767 5.11454 13.5076 5.14134 13.6399 5.14189H16.3599V7.86189C16.3605 7.9942 16.3873 8.12508 16.4388 8.24696C16.4903 8.36883 16.5655 8.47928 16.6599 8.57189L18.5899 10.5019L16.6599 12.4319Z"
                    />
                  </svg>
                </span>
                <span class="sb-title">Operation</span>
              </div>
            </router-link>
          </div>

          <div
            class="sb-link"
            :class="isRouteNames(['HodoMember']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['HodoMember']))"
            data-toggle="tooltip"
            data-placement="right"
            title="operation"
          >
            <router-link to="/admin/hodo-member">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      :stroke="active ? 'white' : '#667085'"
                      d="M7 15.8522H10C10.2652 15.8522 10.5196 15.7468 10.7071 15.5593C10.8946 15.3717 11 15.1174 11 14.8522C11 14.587 10.8946 14.3326 10.7071 14.1451C10.5196 13.9575 10.2652 13.8522 10 13.8522H7C6.73478 13.8522 6.48043 13.9575 6.29289 14.1451C6.10536 14.3326 6 14.587 6 14.8522C6 15.1174 6.10536 15.3717 6.29289 15.5593C6.48043 15.7468 6.73478 15.8522 7 15.8522ZM19 5.85217H5C4.20435 5.85217 3.44129 6.16824 2.87868 6.73085C2.31607 7.29346 2 8.05652 2 8.85217V17.8522C2 18.6478 2.31607 19.4109 2.87868 19.9735C3.44129 20.5361 4.20435 20.8522 5 20.8522H19C19.7956 20.8522 20.5587 20.5361 21.1213 19.9735C21.6839 19.4109 22 18.6478 22 17.8522V8.85217C22 8.05652 21.6839 7.29346 21.1213 6.73085C20.5587 6.16824 19.7956 5.85217 19 5.85217ZM20 17.8522C20 18.1174 19.8946 18.3717 19.7071 18.5593C19.5196 18.7468 19.2652 18.8522 19 18.8522H5C4.73478 18.8522 4.48043 18.7468 4.29289 18.5593C4.10536 18.3717 4 18.1174 4 17.8522V11.8522H20V17.8522ZM20 9.85217H4V8.85217C4 8.58696 4.10536 8.3326 4.29289 8.14507C4.48043 7.95753 4.73478 7.85217 5 7.85217H19C19.2652 7.85217 19.5196 7.95753 19.7071 8.14507C19.8946 8.3326 20 8.58696 20 8.85217V9.85217Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span class="sb-title">HODO Member</span>
              </div>
            </router-link>
          </div>

          <div
            class="sb-link"
            :class="isRouteNames(['NewspaperListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['NewspaperListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Bài viết"
          >
            <router-link to="/admin/newspaper">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 13H18"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 9H15"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.14288 19H19.8572C21.0406 19 22 18.0406 22 16.8571V5.14286C22 3.95939 21.0406 3 19.8572 3H7.71431C6.53084 3 5.57145 3.95939 5.57145 5.14286V11"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                    />
                    <path
                      d="M2 8.05194C2 6.86848 2.95939 5.90909 4.14286 5.90909H5.57143V17.2143C5.57143 18.2005 4.77194 19 3.78571 19V19C2.79949 19 2 18.2005 2 17.2143V8.05194Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                    />
                  </svg>
                </span>
                <span class="sb-title">Bài viết</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="
              isRouteNames(['ServicesOrders', 'MemberPackOrders'])
                ? 'sb-active'
                : ''
            "
            :set="
              (active = isRouteNames(['ServicesOrders', 'MemberPackOrders']))
            "
            data-toggle="tooltip"
            data-placement="right"
            title="Đặt hàng"
          >
            <router-link to="/admin/order">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.01001 11.22V15.71C3.01001 20.2 4.81001 22 9.30001 22H14.69C19.18 22 20.98 20.2 20.98 15.71V11.22"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 12C13.83 12 15.18 10.51 15 8.68L14.34 2H9.66999L8.99999 8.68C8.81999 10.51 10.17 12 12 12Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.31 12C20.33 12 21.81 10.36 21.61 8.35L21.33 5.6C20.97 3 19.97 2 17.35 2H14.3L15 9.01C15.17 10.66 16.66 12 18.31 12Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.64 12C7.29 12 8.78 10.66 8.94 9.01L9.16 6.8L9.64001 2H6.59C3.97001 2 2.97 3 2.61 5.6L2.34 8.35C2.14 10.36 3.62 12 5.64 12Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 17C10.33 17 9.5 17.83 9.5 19.5V22H14.5V19.5C14.5 17.83 13.67 17 12 17Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Đặt hàng</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['CareplanListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['CareplanListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Hồ sơ sức khỏe"
          >
            <router-link to="/admin/care-plan">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 7H16"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 10.5H13"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Hồ sơ sức khỏe</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['ListPacs']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['ListPacs']))"
            data-toggle="tooltip"
            data-placement="right"
            title="PACS"
          >
            <router-link to="/admin/pacs">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.13294 0C1.83839 0 1.59961 0.238782 1.59961 0.533333V4.53333C1.59961 4.82789 1.83839 5.06667 2.13294 5.06667H22.1329C22.4275 5.06667 22.6663 4.82789 22.6663 4.53333V0.533333C22.6663 0.238782 22.4275 0 22.1329 0H2.13294ZM13.7327 3.4667C14.2481 3.4667 14.666 3.04883 14.666 2.53337C14.666 2.0179 14.2481 1.60003 13.7327 1.60003L3.59935 1.60003C3.08388 1.60003 2.66602 2.0179 2.66602 2.53337C2.66602 3.04883 3.08388 3.4667 3.59935 3.4667L13.7327 3.4667ZM18.6662 2.53337C18.6662 3.04883 18.2483 3.4667 17.7329 3.4667C17.2174 3.4667 16.7995 3.04883 16.7995 2.53337C16.7995 2.0179 17.2174 1.60003 17.7329 1.60003C18.2483 1.60003 18.6662 2.0179 18.6662 2.53337ZM20.6661 3.4667C21.1815 3.4667 21.5994 3.04883 21.5994 2.53337C21.5994 2.0179 21.1815 1.60003 20.6661 1.60003C20.1506 1.60003 19.7327 2.0179 19.7327 2.53337C19.7327 3.04883 20.1506 3.4667 20.6661 3.4667Z"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.13294 6.1333C1.83839 6.1333 1.59961 6.37208 1.59961 6.66663V10.6666C1.59961 10.9612 1.83839 11.2 2.13294 11.2H22.1329C22.4275 11.2 22.6663 10.9612 22.6663 10.6666V6.66663C22.6663 6.37208 22.4275 6.1333 22.1329 6.1333H2.13294ZM13.7327 9.6C14.2481 9.6 14.666 9.18213 14.666 8.66667C14.666 8.1512 14.2481 7.73333 13.7327 7.73333L3.59935 7.73333C3.08388 7.73333 2.66602 8.1512 2.66602 8.66667C2.66602 9.18213 3.08388 9.6 3.59935 9.6L13.7327 9.6ZM18.6662 8.66667C18.6662 9.18213 18.2483 9.6 17.7329 9.6C17.2174 9.6 16.7995 9.18213 16.7995 8.66667C16.7995 8.1512 17.2174 7.73333 17.7329 7.73333C18.2483 7.73333 18.6662 8.1512 18.6662 8.66667ZM20.6661 9.6C21.1815 9.6 21.5994 9.18213 21.5994 8.66667C21.5994 8.1512 21.1815 7.73333 20.6661 7.73333C20.1506 7.73333 19.7327 8.1512 19.7327 8.66667C19.7327 9.18213 20.1506 9.6 20.6661 9.6Z"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.0674 18.9332C13.0674 18.6387 12.8287 18.3999 12.5341 18.3999H11.7341C11.4396 18.3999 11.2008 18.6387 11.2008 18.9332V20.2666C11.2008 20.5611 10.962 20.7999 10.6674 20.7999H9.60072C9.30616 20.7999 9.06738 21.0387 9.06738 21.3332V23.4666C9.06738 23.7611 9.30616 23.9999 9.60072 23.9999H14.6674C14.9619 23.9999 15.2007 23.7611 15.2007 23.4666V21.3332C15.2007 21.0387 14.9619 20.7999 14.6674 20.7999H13.6008C13.3062 20.7999 13.0674 20.5611 13.0674 20.2666V18.9332Z"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <rect
                      x="2.66699"
                      y="21.8667"
                      width="5.33333"
                      height="1.06667"
                      rx="0.533333"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <rect
                      x="0.533203"
                      y="21.8667"
                      width="1.06667"
                      height="1.06667"
                      rx="0.533333"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <rect
                      x="22.667"
                      y="21.8667"
                      width="1.06667"
                      height="1.06667"
                      rx="0.533333"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <rect
                      x="16.2666"
                      y="21.8667"
                      width="5.33333"
                      height="1.06667"
                      rx="0.533333"
                      :fill="active ? 'white' : '#41464B'"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.13294 12.2666C1.83839 12.2666 1.59961 12.5054 1.59961 12.7999V16.7999C1.59961 17.0945 1.83839 17.3333 2.13294 17.3333H22.1329C22.4275 17.3333 22.6663 17.0945 22.6663 16.7999V12.7999C22.6663 12.5054 22.4275 12.2666 22.1329 12.2666H2.13294ZM13.7327 15.7333C14.2481 15.7333 14.666 15.3154 14.666 14.8C14.666 14.2845 14.2481 13.8666 13.7327 13.8666L3.59935 13.8666C3.08388 13.8666 2.66602 14.2845 2.66602 14.8C2.66602 15.3154 3.08388 15.7333 3.59935 15.7333L13.7327 15.7333ZM18.6662 14.8C18.6662 15.3154 18.2483 15.7333 17.7329 15.7333C17.2174 15.7333 16.7995 15.3154 16.7995 14.8C16.7995 14.2845 17.2174 13.8666 17.7329 13.8666C18.2483 13.8666 18.6662 14.2845 18.6662 14.8ZM20.6661 15.7333C21.1815 15.7333 21.5994 15.3154 21.5994 14.8C21.5994 14.2845 21.1815 13.8666 20.6661 13.8666C20.1506 13.8666 19.7327 14.2845 19.7327 14.8C19.7327 15.3154 20.1506 15.7333 20.6661 15.7333Z"
                      :fill="active ? 'white' : '#41464B'"
                    />
                  </svg>
                </span>
                <span class="sb-title">PACS</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="
              isRouteNames([
                'DiseaseTemplate',
                'DiseaseTemplateCreate',
                'DiseaseTemplateDetail',
              ])
                ? 'sb-active'
                : ''
            "
            :set="
              (active = isRouteNames([
                'DiseaseTemplate',
                'DiseaseTemplateCreate',
                'DiseaseTemplateDetail',
              ]))
            "
            data-toggle="tooltip"
            data-placement="right"
            title="Mẫu hồ sơ sức khỏe"
          >
            <router-link to="/admin/diseases-templates">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 2C16 2 17 3.01 17 5.03V12.08C17 14.07 15.59 14.84 13.86 13.8L12.54 13C12.24 12.82 11.76 12.82 11.46 13L10.14 13.8C8.41 14.84 7 14.07 7 12.08V5.03C7 3.01 8 2 10 2H14Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.82 4.99001C3.41 5.56001 2 7.66001 2 11.9V14.93C2 19.98 4 22 9 22H15C20 22 22 19.98 22 14.93V11.9C22 7.59001 20.54 5.48001 17 4.96001"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Mẫu hồ sơ sức khỏe</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['StatsList']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['StatsList']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Chỉ số"
          >
            <router-link to="/admin/survival-stats">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22 16.74V4.67001C22 3.47001 21.02 2.58001 19.83 2.68001H19.77C17.67 2.86001 14.48 3.93001 12.7 5.05001L12.53 5.16001C12.24 5.34001 11.76 5.34001 11.47 5.16001L11.22 5.01001C9.44 3.90001 6.26 2.84001 4.16 2.67001C2.97 2.57001 2 3.47001 2 4.66001V16.74C2 17.7 2.78 18.6 3.74 18.72L4.03 18.76C6.2 19.05 9.55 20.15 11.47 21.2L11.51 21.22C11.78 21.37 12.21 21.37 12.47 21.22C14.39 20.16 17.75 19.05 19.93 18.76L20.26 18.72C21.22 18.6 22 17.7 22 16.74Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 5.49001V20.49"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.75 8.49001H5.5"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.5 11.49H5.5"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Chỉ số</span>
              </div>
            </router-link>
          </div>

          <div
            class="sb-link"
            :class="isRouteNames(['PackagesManagement']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['PackagesManagement']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Gói tài khoản"
          >
            <router-link to="/admin/packages">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 15.29V5.71C2 4.38 2.77 4.06 3.71 5L6.3 7.59C6.69 7.98 7.33 7.98 7.71 7.59L11.29 4C11.68 3.61 12.32 3.61 12.7 4L16.29 7.59C16.68 7.98 17.32 7.98 17.7 7.59L20.29 5C21.23 4.06 22 4.38 22 5.71V15.3C22 18.3 20 20.3 17 20.3H7C4.24 20.29 2 18.05 2 15.29Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Gói tài khoản</span>
              </div>
            </router-link>
          </div>

          <div
            class="sb-link"
            :class="isRouteNames(['ServiceListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['ServiceListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Dịch vụ"
          >
            <router-link to="/admin/service">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.26001 11.02V15.99C4.26001 17.81 4.26001 17.81 5.98001 18.97L10.71 21.7C11.42 22.11 12.58 22.11 13.29 21.7L18.02 18.97C19.74 17.81 19.74 17.81 19.74 15.99V11.02C19.74 9.2 19.74 9.2 18.02 8.04L13.29 5.31C12.58 4.9 11.42 4.9 10.71 5.31L5.98001 8.04C4.26001 9.2 4.26001 9.2 4.26001 11.02Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.63 10.99L13.2 11.88C13.29 12.02 13.49 12.16 13.64 12.2L14.66 12.46C15.29 12.62 15.46 13.16 15.05 13.66L14.38 14.47C14.28 14.6 14.2 14.83 14.21 14.99L14.27 16.04C14.31 16.69 13.85 17.02 13.25 16.78L12.27 16.39C12.12 16.33 11.87 16.33 11.72 16.39L10.74 16.78C10.14 17.02 9.67999 16.68 9.71999 16.04L9.77999 14.99C9.78999 14.83 9.70999 14.59 9.60999 14.47L8.93999 13.66C8.52999 13.16 8.69999 12.62 9.32999 12.46L10.35 12.2C10.51 12.16 10.71 12.01 10.79 11.88L11.36 10.99C11.72 10.45 12.28 10.45 12.63 10.99Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Dịch vụ</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['ContactListAdmin']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['ContactListAdmin']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Account"
          >
            <router-link to="/admin/contact-list">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.97 14.44C18.34 14.67 19.85 14.43 20.91 13.72C22.32 12.78 22.32 11.24 20.91 10.3C19.84 9.59001 18.31 9.35 16.94 9.59"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.97001 7.16C6.03001 7.15 6.10001 7.15 6.16001 7.16C7.54001 7.11 8.64001 5.98 8.64001 4.58C8.64001 3.15 7.49001 2 6.06001 2C4.63001 2 3.48001 3.16 3.48001 4.58C3.49001 5.98 4.59001 7.11 5.97001 7.16Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 14.44C5.63 14.67 4.12 14.43 3.06 13.72C1.65 12.78 1.65 11.24 3.06 10.3C4.13 9.59001 5.66 9.35 7.03 9.59"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 14.63C11.94 14.62 11.87 14.62 11.81 14.63C10.43 14.58 9.33002 13.45 9.33002 12.05C9.33002 10.62 10.48 9.47 11.91 9.47C13.34 9.47 14.49 10.63 14.49 12.05C14.48 13.45 13.38 14.59 12 14.63Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.09 17.78C7.68 18.72 7.68 20.26 9.09 21.2C10.69 22.27 13.31 22.27 14.91 21.2C16.32 20.26 16.32 18.72 14.91 17.78C13.32 16.72 10.69 16.72 9.09 17.78Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Tài khoản</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['PersonAdminListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['PersonAdminListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Contact"
          >
            <router-link to="/admin/persons">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Bệnh nhân</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['AdminDoctorListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['AdminDoctorListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Doctor"
          >
            <router-link to="/admin/doctors">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.5 8.25V3.75C16.5 2.5095 15.4905 1.5 14.25 1.5H9.75C8.5095 1.5 7.5 2.5095 7.5 3.75V8.25C7.5 10.7318 9.51825 12.75 12 12.75C14.4818 12.75 16.5 10.7318 16.5 8.25ZM9 3.75C9 3.33675 9.33675 3 9.75 3H14.25C14.6632 3 15 3.33675 15 3.75V4.5H9V3.75ZM9 8.25V6H15V8.25C15 8.38425 14.9775 8.5125 14.9603 8.64225C14.1495 7.923 13.1017 7.5 12 7.5C10.8983 7.5 9.8505 7.923 9.03975 8.64225C9.0225 8.5125 9 8.38425 9 8.25ZM12 9C12.9165 9 13.7557 9.4155 14.3212 10.1265C13.7707 10.806 12.9405 11.25 12 11.25C11.0595 11.25 10.2292 10.806 9.67875 10.1265C10.2442 9.4155 11.0835 9 12 9Z"
                      :stroke="active ? 'white' : '#718096'"
                    />
                    <path
                      d="M17.25 13.5H6.75C4.68225 13.5 3 15.1823 3 17.25V21.75C3 22.164 3.336 22.5 3.75 22.5H20.25C20.664 22.5 21 22.164 21 21.75V17.25C21 15.1823 19.3177 13.5 17.25 13.5ZM19.5 21H4.5V17.25C4.5 16.0095 5.5095 15 6.75 15H8.25V15.8565C6.96 16.1918 6 17.3565 6 18.75V19.5C6 19.914 6.336 20.25 6.75 20.25H7.5C7.914 20.25 8.25 19.914 8.25 19.5C8.25 19.086 7.914 18.75 7.5 18.75C7.5 17.9227 8.17275 17.25 9 17.25C9.82725 17.25 10.5 17.9227 10.5 18.75C10.086 18.75 9.75 19.086 9.75 19.5C9.75 19.914 10.086 20.25 10.5 20.25H11.25C11.664 20.25 12 19.914 12 19.5V18.75C12 17.3565 11.04 16.1918 9.75 15.8565V15H15V16.7078C14.5538 16.9673 14.25 17.4457 14.25 18C14.25 18.8288 14.9213 19.5 15.75 19.5C16.5787 19.5 17.25 18.8288 17.25 18C17.25 17.4465 16.9462 16.968 16.5 16.7078V15H17.25C18.4905 15 19.5 16.0095 19.5 17.25V21Z"
                      :stroke="active ? 'white' : '#718096'"
                    />
                  </svg>
                </span>
                <span class="sb-title">Bác sĩ</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['permisionsListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['permisionsListing']))"
            data-toggle="tooltip"
            data-placement="right"
            title="Permisions"
          >
            <router-link to="/admin/permisions">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 8H4C2.9 8 2 7.1 2 6V4C2 2.9 2.9 2 4 2H7C8.1 2 9 2.9 9 4V6C9 7.1 8.1 8 7 8Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.8 7H17.2C16.54 7 16 6.45999 16 5.79999V4.20001C16 3.54001 16.54 3 17.2 3H20.8C21.46 3 22 3.54001 22 4.20001V5.79999C22 6.45999 21.46 7 20.8 7Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.8 14.5H17.2C16.54 14.5 16 13.96 16 13.3V11.7C16 11.04 16.54 10.5 17.2 10.5H20.8C21.46 10.5 22 11.04 22 11.7V13.3C22 13.96 21.46 14.5 20.8 14.5Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 5H16"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 5V18C12.5 19.1 13.4 20 14.5 20H16"
                      :stroke="active ? 'white' : '#718096'"
                    />
                    <path
                      d="M12.5 5V18C12.5 19.1 13.4 20 14.5 20H16"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 12.5H16"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.8 22H17.2C16.54 22 16 21.46 16 20.8V19.2C16 18.54 16.54 18 17.2 18H20.8C21.46 18 22 18.54 22 19.2V20.8C22 21.46 21.46 22 20.8 22Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Phân quyền</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['sendMessagesInApp']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['sendMessagesInApp']))"
            data-toggle="tooltip"
            data-placement="right"
            alt="Message"
          >
            <router-link to="/admin/send-message">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 8H17"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 13H13"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Gửi tin nhắn In-App</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['GroupQuestion']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['GroupQuestion']))"
            data-toggle="tooltip"
            data-placement="right"
            alt="Group Question"
          >
            <router-link to="/admin/group-question">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.63814 10.1523C4.06477 10.5683 2.08334 12.814 2.08334 15.5C2.08334 18.4792 4.52084 20.9167 7.50001 20.9167C8.01986 20.9167 8.52321 20.8425 9 20.7041"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15 20.6667C18.6667 20.6667 21.6667 17.6667 21.6667 14C21.6667 10.3333 18.6667 7.33334 15 7.33334C11.3333 7.33334 8.33334 10.3333 8.33334 14C8.33334 17.6667 11.3333 20.6667 15 20.6667Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.4608 14.9051L14.4608 14.9051L14.4605 14.9064C14.4327 15.0124 14.4114 15.1305 14.3961 15.2605C14.3543 15.6151 14.6492 15.8935 14.9859 15.8935C15.3301 15.8935 15.5838 15.615 15.6407 15.3042C15.6552 15.2253 15.6734 15.1487 15.6956 15.0742C15.7554 14.8726 15.8725 14.6886 16.0521 14.5221L16.0526 14.5216C16.2814 14.3071 16.4978 14.0818 16.7017 13.8457C16.9095 13.6051 17.0796 13.3474 17.2115 13.0726C17.3507 12.7866 17.4196 12.4752 17.4196 12.1403C17.4196 11.7111 17.3334 11.3335 17.1557 11.012C16.9776 10.6861 16.7174 10.4358 16.3786 10.2626C16.043 10.0892 15.6415 10.0055 15.1791 10.0055C14.7577 10.0055 14.3728 10.0843 14.0265 10.2444C13.679 10.4051 13.4 10.6382 13.1928 10.9435L13.1928 10.9435L13.1922 10.9444C13.077 11.1171 12.9935 11.3084 12.941 11.5173C12.8495 11.882 13.1656 12.1648 13.4971 12.1648C13.8408 12.1648 14.0687 11.8767 14.1881 11.6256C14.2068 11.5862 14.2286 11.5499 14.2533 11.5168L14.2533 11.5168L14.2541 11.5157C14.3527 11.3801 14.4817 11.2798 14.6441 11.2143C14.812 11.1464 14.99 11.1123 15.1791 11.1123C15.4102 11.1123 15.5936 11.1569 15.7356 11.2385L15.7356 11.2385L15.7366 11.239C15.8833 11.3216 15.9924 11.4381 16.066 11.5914L16.066 11.5914L16.0669 11.5932C16.1445 11.7486 16.1859 11.9384 16.1859 12.1667C16.1859 12.3918 16.1462 12.5782 16.0719 12.7301C15.993 12.8878 15.889 13.0366 15.7592 13.1765L15.7591 13.1766C15.626 13.3202 15.4787 13.4745 15.3171 13.6395L15.3167 13.64C15.0923 13.8716 14.9103 14.0803 14.7721 14.2658C14.6287 14.4583 14.5249 14.6716 14.4608 14.9051ZM14.5045 16.9594C14.3833 17.0935 14.3242 17.2581 14.3242 17.4451C14.3242 17.6267 14.3844 17.7873 14.5045 17.9203C14.633 18.0625 14.8136 18.1255 15.0257 18.1255C15.2404 18.1255 15.4232 18.063 15.5521 17.9203C15.6723 17.7873 15.7325 17.6267 15.7325 17.4451C15.7325 17.2581 15.6733 17.0935 15.5521 16.9594C15.4232 16.8166 15.2404 16.7542 15.0257 16.7542C14.8136 16.7542 14.633 16.8171 14.5045 16.9594Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="0.25"
                    />
                    <path
                      d="M6.08334 8.5C6.08334 5.52084 8.52084 3.08334 11.5 3.08334C13.2775 3.08334 14.8621 3.95099 15.8513 5.28368"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Nhóm câu hỏi</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['questionListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['questionListing']))"
            data-toggle="tooltip"
            data-placement="right"
            alt="Question"
          >
            <router-link to="/admin/question">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.7766 13.9226C12.7036 14.3213 12.3842 14.6528 11.9789 14.6528C11.5705 14.6528 11.2326 14.3182 11.2803 13.9127C11.3025 13.7245 11.3331 13.556 11.3721 13.4072C11.462 13.0793 11.6075 12.7805 11.8084 12.5108C12.0094 12.241 12.2765 11.9343 12.6097 11.5905C12.853 11.3419 13.0751 11.1092 13.2761 10.8923C13.4824 10.6702 13.649 10.4322 13.7759 10.1783C13.9029 9.91917 13.9663 9.60976 13.9663 9.25011C13.9663 8.88518 13.9002 8.57048 13.768 8.30604C13.6411 8.04159 13.4507 7.83796 13.1968 7.69516C12.9482 7.55236 12.6388 7.48096 12.2686 7.48096C11.9618 7.48096 11.6709 7.53649 11.3959 7.64756C11.1209 7.75863 10.8987 7.93052 10.7295 8.16323C10.6849 8.22318 10.646 8.28808 10.6127 8.35794C10.4408 8.71961 10.146 9.05971 9.74558 9.05971C9.33596 9.05971 8.99374 8.71893 9.09341 8.32163C9.16708 8.02799 9.28403 7.76099 9.44427 7.52062C9.73517 7.09222 10.1265 6.7643 10.6184 6.53688C11.1103 6.30945 11.6603 6.19574 12.2686 6.19574C12.9403 6.19574 13.5115 6.31739 13.9822 6.56068C14.4582 6.80397 14.8205 7.15304 15.0691 7.60789C15.3177 8.05745 15.442 8.59164 15.442 9.21045C15.442 9.68645 15.3441 10.1254 15.1484 10.5274C14.958 10.9241 14.7121 11.2969 14.4106 11.646C14.1091 11.9951 13.7892 12.3283 13.4507 12.6456C13.1598 12.9154 12.9641 13.2195 12.8636 13.558C12.8285 13.6763 12.7995 13.7978 12.7766 13.9226ZM11.1738 17.1677C11.1738 16.9297 11.2478 16.7287 11.3959 16.5647C11.544 16.4008 11.7582 16.3188 12.0385 16.3188C12.3241 16.3188 12.541 16.4008 12.6891 16.5647C12.8371 16.7287 12.9112 16.9297 12.9112 17.1677C12.9112 17.3951 12.8371 17.5908 12.6891 17.7548C12.541 17.9187 12.3241 18.0007 12.0385 18.0007C11.7582 18.0007 11.544 17.9187 11.3959 17.7548C11.2478 17.5908 11.1738 17.3951 11.1738 17.1677Z"
                      :stroke="active ? 'white' : '#718096'"
                    />
                  </svg>
                </span>
                <span class="sb-title">Câu hỏi</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="
              isRouteNames(['ClinicListing', 'ClinicEdit', 'ClinicAdd'])
                ? 'sb-active'
                : ''
            "
            :set="
              (active = isRouteNames([
                'ClinicListing',
                'ClinicEdit',
                'ClinicAdd',
              ]))
            "
            data-toggle="tooltip"
            data-placement="right"
            alt="Question"
          >
            <router-link to="/clinics">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 22H22"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 2H7C4 2 3 3.79 3 6V22H21V6C21 3.79 20 2 17 2Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.06 15H9.92998C9.41998 15 8.98999 15.42 8.98999 15.94V22H14.99V15.94C15 15.42 14.58 15 14.06 15Z"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 6V11"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.5 8.5H14.5"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">
                  {{
                  $t("workspace_setting.lbl_workspace")[$orgModel]
                  }}
                </span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['ClinicAppliesListing']) ? 'sb-active' : ''"
            :set="(active = isRouteNames(['ClinicAppliesListing']))"
            data-toggle="tooltip"
            data-placement="right"
            alt="Clinic Applies"
          >
            <router-link to="/applies">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 22H12"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3 22V6C3 3.79 4 2 7 2H17C20 2 21 3.79 21 6V11"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.98999 22V15.94C8.98999 15.42 9.41998 15 9.92998 15H13"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 6V11"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.5 8.5H14.5"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.5 16V21"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 18.5H21"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="18.5"
                      cy="18.5"
                      r="4.75"
                      :stroke="active ? 'white' : '#41464B'"
                      stroke-width="1.5"
                    />
                  </svg>
                </span>
                <span class="sb-title">
                  {{
                  $t("workspace_setting.lbl_workspace_register")[$orgModel]
                  }}
                </span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link d-none"
            :class="isRouteNames(['InvoiceListing']) ? 'sb-active' : ''"
            data-toggle="tooltip"
            data-placement="right"
            alt="Invoices"
          >
            <router-link to="/admin/invoice">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <img
                    v-if="!isRouteNames(['InvoiceListing'])"
                    src="https://img.icons8.com/fluent-systems-regular/32/000000/file-invoice-dollar.png"
                    alt="Invoices"
                  />
                  <img
                    v-if="isRouteNames(['InvoiceListing'])"
                    src="https://img.icons8.com/fluent-systems-regular/32/ffffff/file-invoice-dollar.png"
                    alt="Invoices"
                  />
                </span>
                <span class="sb-title">Hoá đơn</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link d-none"
            :class="isRouteNames(['bankAccountListing']) ? 'sb-active' : ''"
            data-toggle="tooltip"
            data-placement="right"
            alt="Bank account"
          >
            <router-link to="/admin/bank-account">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <img
                    v-if="!isRouteNames(['bankAccountListing'])"
                    src="https://img.icons8.com/material/32/000000/merchant-account.png"
                    alt="Bank account"
                  />
                  <img
                    v-if="isRouteNames(['bankAccountListing'])"
                    src="https://img.icons8.com/material/32/ffffff/merchant-account.png"
                    alt="Bank account"
                  />
                </span>
                <span class="sb-title">Thông tin ngân hàng</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link d-none"
            :class="isRouteNames(['AdminTemplateListing']) ? 'sb-active' : ''"
            data-toggle="tooltip"
            data-placement="right"
            alt="Templates"
          >
            <router-link to="/admin/templates">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <img
                    v-if="!isRouteNames(['AdminTemplateListing'])"
                    src="https://img.icons8.com/windows/32/000000/document--v1.png"
                    alt="Templates"
                  />
                  <img
                    v-if="isRouteNames(['AdminTemplateListing'])"
                    src="https://img.icons8.com/windows/32/ffffff/document--v1.png"
                    alt="Templates"
                  />
                </span>
                <span class="sb-title">Mẫu</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link"
            :class="isRouteNames(['PatientState']) ? 'sb-active' : ''"
            data-toggle="tooltip"
            data-placement="right"
            alt="Templates"
          >
            <router-link to="/admin/patient-states">
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <span class="sb-title">Patient State</span>
              </div>
            </router-link>
          </div>
          <div
            class="sb-link cursor-pointer"
            @click="onLogout"
            title="Đăng xuất"
            data-toggle="tooltip"
            data-placement="right"
          >
            <div>
              <div class="sb-link-content">
                <span class="sb-icon">
                  <svg
                    width="19"
                    height="21"
                    viewBox="0 0 19 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8125 10.5225H0.771484"
                      stroke="#718096"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.88477 7.60645L12.8128 10.5224L9.88477 13.4384"
                      stroke="#718096"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.50439 5.88946V4.95646C5.50439 2.92146 7.15339 1.27246 9.18939 1.27246H14.0734C16.1034 1.27246 17.7484 2.91746 17.7484 4.94746V16.0875C17.7484 18.1225 16.0984 19.7725 14.0634 19.7725H9.17839C7.14939 19.7725 5.50439 18.1265 5.50439 16.0975V15.1555"
                      stroke="#718096"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="sb-title">Đăng xuất</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import { APP_MODE } from '@/utils/constants'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { isMobile, isTablet } from 'mobile-device-detect'
import { menuSidebar } from './Menu'
import SignatureIcon from '../Icon/Sidebar/SignatureIcon.vue'

export default {
  name: 'Sidebar',
  props: ['extraSidebar', 'isClinic', 'isDoctor', 'isAdmin', SignatureIcon],
  mixins: [mixinHasFeatures],
  data () {
    return {
      current_route_name: '',
      curr_clinic: null,
      my_actions: 0,
      total_unread: 0,
      appUtils,
      finished_info: false,
      mode: APP_MODE.workspace,
      menuSidebar
    }
  },
  watch: {
    $route (to, from) {
      let self = this
      self.current_route_name = to.name
    },
    $user (u) {
      this.finished_info = u && !!u.name
    },
    extraSidebar (s) {
      if (s) {
        window.$('[data-toggle="tooltip"]').tooltip('disable')
      } else {
        window.$('[data-toggle="tooltip"]').tooltip('enable')
      }
    },
    $appMode (value) {
      this.mode = Number(value) === APP_MODE.organization ? APP_MODE.organization : APP_MODE.workspace
    },
    $globalOrg: {
      deep: true,
      handler () {
        this.getFeatureOrgList()
      }
    },
    '$conversationsList.total_unread': {
      handler (data) {
        this.total_unread = data
      }
    }
  },
  computed: {
    hasSign () {
      return this.$featureWsList && this.$featureWsList['digital_signature']
    },
    goToConversation () {
      const domain = window.location.hostname === 'localhost' ? 'http://localhost:3000' : process.env.VUE_APP_HODO_CONVERSATION
      const routeRaw = `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${this.$lang}`

      // console.log(routeRaw)
      return routeRaw
    },
    isProcessor () {
      return this.$user?.processors?.length
    },
    linkPartner () {
      const token = localStorage.getItem('jwt_token')
      const orgId = this.$globalOrg?.id
      if (!token || !orgId) return ''

      // TODO: Remove when have api
      const IS_TEST_PROVIDE = 1

      if (process.env.NODE_ENV === 'development') {
        return IS_TEST_PROVIDE === 1 ? `https://dev.lab.hodo.app/#/auto-login?token=${token}&org_id=${orgId}` : `https://dev.marketplace.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
      } else {
        return IS_TEST_PROVIDE === 1 ? `https://lab.hodo.app/#/auto-login?token=${token}&org_id=${orgId}` : `https://marketplace.hodo.app/#/auto-login?token=${token}&org_id=${orgId}`
      }
    },
    linkMarketplace () {
      const token = localStorage.getItem('jwt_token')
      const org_id = this.$globalClinic?.org_id
      const ws_id = this.$globalClinic?.id

      if (!token || (!ws_id && !org_id)) return ''

      if (process.env.NODE_ENV === 'development') {
        return `https://dev.internal.marketplace.hodo.app/#/auto-login?token=${token}&ws_id=${ws_id}&org_id=${org_id}`
      } else {
        return `https://internal.marketplace.hodo.app/#/auto-login?token=${token}&ws_id=${ws_id}&org_id=${org_id}`
      }
    },
    linkPharma () {
      const token = localStorage.getItem('jwt_token')
      const org_id = this.$globalOrg?.id

      if (!token || !org_id) return ''
      if (process.env.NODE_ENV === 'development') {
        // return `http://localhost:8087/#/hello-world`
        // return `https://dev.pharma.hodo.app/#/auto-login?token=${token}&org_id=${org_id}`
        return `https://dev.pharma.hodo.app/#/`
      } else {
        return `https://pharma.hodo.app/#/`
      }
    },
    linkMarketplaceWarehouse () {
      const token = localStorage.getItem('jwt_token')
      const org_id = this.$globalOrg?.id
      const ws_id = this.$globalClinic?.id
      let link = ''

      if (!token || (!ws_id && !org_id)) return ''

      if (process.env.NODE_ENV === 'development') {
        if (this.mode === 1) {
          link = `https://dev.marketplace.hodo.app/#/auto-login?token=${token}&ws_id=${ws_id}`
        } else if (this.mode === 2) {
          link = `https://dev.marketplace.hodo.app/#/auto-login?token=${token}&ws_id=${ws_id}`
        }
        return link
      } else {
        if (this.mode === 1) {
          link = `https://marketplace.hodo.app/#/auto-login?token=${token}&ws_id=${ws_id}`
        } else if (this.mode === 2) {
          link = `https://marketplace.hodo.app/#/auto-login?token=${token}&org_id=${org_id}`
        }

        return link
      }
    },
    emrMobileViewLink () {
      const token = localStorage.getItem('jwt_token')
      const org_id = this.$globalClinic?.org_id
      const ws_id = this.$globalClinic?.id

      if (!token || (!ws_id && !org_id)) return ''

      let url
      if (process.env.NODE_ENV === 'development') {
        url = `https://beta.v2.hodo.app/#/emr-list?org_id=${org_id}&ws_id=${ws_id}&token=${token}`

        // url = `http://localhost:9051/#/emr-list?org_id=${org_id}&ws_id=${ws_id}&token=${token}`
      } else {
        url = `https://beta.v2.hodo.app/#/emr-list?org_id=${org_id}&ws_id=${ws_id}&token=${token}`
      }
      return url
    },
    indexActive () {
      const home = ['HomePage', 'Workspace']
      const orgHCP = ['Organization', 'OrganizationManagement', 'OrganizationDetail', 'OrganizationDetailUpdate']
      const orgWS = ['OrganizationListWs', 'OrganizationWsStaffManage']
      const orgEmployee = ['OrgEmployeeManage']
      const orgSetting = ['OrganizationUpdate']
      const wsHSBA = ['ListBenhAn', 'ElectronicMedicalRecords', 'MRSate', 'ERMMapView', 'ERMTreeView', 'EMRVersion', 'EMRWrapper']
      const wsSKB = ['HealthRecords', 'HealthRecordMed', 'PhieuKhamBenhDetail', 'IndicationListHR', 'ListPatientVisit', 'DetailPatientVisit', 'ListPatientVisitV2', 'DetailPatientVisitV2']
      const wsHSSK = ['PersonDiseasesManagement', 'DiseasesOverview', 'DiseasesPrescriptionList', 'HealthInformation', 'UpdateHealthInformation', 'ProfileHistory', 'MedicineAdd', 'Diseases', 'WaitingList', 'TestInformationManagement', 'DiseasesActivity', 'TopicCreate', 'DocumentManagement', 'DiseasesHealthInformation', 'AnswerListing', 'TopicDetail', 'ConsultationUpdate', 'LichSuPhieuTuVan', 'ConsultationCreate', 'WaitingProfileDetails', 'TestDetail', 'DiseasesCreate', 'PersonMedicineSchedule', 'TodoList', 'HeartRate']
      const wsHSSKOverview = ['HealthRecordOverview', 'HealthRecordOverviewDetail']
      const wsPatient = ['ContactList', 'ContactDetail']
      const wsAppt = ['AppointmentManagement', 'CreateAppointment', 'UpdateAppointment', 'AppointmentDetail', 'InvoiceDetail']
      const wsHCP = ['CreateMdt', 'MdtRoomUpdate', 'MdtDiseaseDetail', 'UpdateMdtDisease', 'SessionDetail', 'CreateMdtDisease', 'OrganizationMdtDiseaseDetail', 'OperationPrint']
      const MDT = ['ListMdt']
      const MEETING = ['Meeting']

      const wsChat = ['ChatPage']
      const wsCircle = ['CircleList', 'CircleDetail', 'CircleChat', 'CircleDocuments', 'LiveCircleDetail', 'CircleSessionDetail', 'CircleLiveDetail', 'CircleConferenceDetail']
      const wsSetting = ['ClinicTariffManage', 'ClinicStatsManage', 'ClinicDiseaseTempManage', 'ClinicPersonnelManage', 'ClinicBankManage', 'ClinicInfoManage', 'DoctorTemplateClone', 'ConcludingList', 'SettingBenhAn', 'ClinicConsultingRooms', 'EmrList', 'EmrTemplateDetail', 'DepositPointsWS', 'DepositForDoctorsWS', 'DepositDetailWS', 'ListService', 'CreateServiceLocal', 'EditServiceLocal']
      const userSetting = ['DoctorSetting']
      const appointmentPages = ['AppointmentManagementV2', 'AppointmentDetailV2']
      const patientVisitPages = ['PatientVisitManagement', 'PatientVisitDetail']
      const workSchedulesPage = ['WorkSchedules']
      const livestreamPage = ['Livestream']
      const DigitalSignature = ['DigitalSignature']
      const conferencePages = ['OrganizationConferenceDetail', 'OrgConferenceList', 'WorkspaceConference', 'WorkspaceConferenceDetail', 'WorkspaceConferenceSessionDetail', 'WorkspaceConferenceDocument', 'WorkspaceConferenceDocumentFolder', 'ConferenceListMember']

      const Ecom = ['OrganizationEcom']
      const wsBed = ['RoomService', 'ListBed']
      const HodoCreditAccumulate = ['HodoCreditAccumulate']
      const HodoCreditConfig = ['HodoCreditConfig']
      const HodoCreditDeposit = ['HodoCreditDeposit', 'HodoCreditDepositForDoctors', 'HodoCreditDepositDetail']

      const ServiceManagement = ['ServiceManagement']
      const ServiceCatalog = ['ServiceCatalog', 'CreateServiceCatalog', 'EditServiceCatalog']
      const PaymentManagement = ['PaymentManagement']

      if (this.isRouteNames(home)) return '0'
      if (this.isRouteNames(orgHCP) || this.isRouteNames(wsSKB)) return '1'
      if (this.isRouteNames(wsHSBA)) return '2'
      if (this.isRouteNames(wsHSSKOverview)) {
        return '3'
      }
      if (this.isRouteNames(wsHSSK) || this.isRouteNames(orgWS)) return '4'

      if (this.isRouteNames(wsPatient) || this.isRouteNames(orgEmployee)) {
        return '5'
      }
      if (this.isRouteNames(wsAppt) || this.isRouteNames(Ecom)) return '6'
      if (this.isRouteNames(wsHCP)) return '7'
      if (this.isRouteNames(orgSetting) || this.isRouteNames(wsChat)) {
        return '8'
      }
      if (this.isRouteNames(wsCircle)) return '104'
      if (this.isRouteNames(wsSetting)) return '11'
      if (this.isRouteNames(userSetting)) return '12'
      if (this.isRouteNames(appointmentPages)) return '100'
      if (this.isRouteNames(patientVisitPages)) return '101'
      if (this.isRouteNames(workSchedulesPage)) return '102'
      if (this.isRouteNames(wsBed)) return '103'
      if (this.isRouteNames(PaymentManagement)) return '107'

      if (this.isRouteNames(livestreamPage)) return '15'
      if (this.isRouteNames(DigitalSignature)) return '16'

      if (this.isRouteNames(conferencePages)) return '200'
      if (this.isRouteNames(MDT)) return '201'
      if (this.isRouteNames(MEETING)) return '202'
      if (this.isRouteNames(HodoCreditAccumulate)) return '123-1'
      if (this.isRouteNames(HodoCreditDeposit)) return '123-2'
      if (this.isRouteNames(HodoCreditConfig)) return '123-3'
      if (this.isRouteNames(ServiceManagement)) return '120-1'
      if (this.isRouteNames(ServiceCatalog)) return '120-2'

      return '0'
    },
    isDisableLivestreamMenu () {
      if (!this.$globalOrg?.owner_id || this.checkRoleOwnerOrg(this.$globalOrg) || this.$globalOrg?.live_room_id) {
        return false
      }
      return true
    }
  },
  created () {},
  async mounted () {
    let self = this
    this.finished_info = this.$user && !!this.$user.name
    self.current_route_name = self.$router.currentRoute.name
    if (self.isDoctor) {
      self.curr_clinic = this.$globalClinic
    }
    window.$(document).ready(function () {
      window.$('[data-toggle="tooltip"]').tooltip()
      if (self.extraSidebar) {
        window.$('[data-toggle="tooltip"]').tooltip('disable')
      }
    })
    self.mode = self.$appMode

    await this.getFeatureOrgList()
  },
  methods: {
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    onOpenSidebar () {
      this.$emit('onOpenSidebar')
    },
    isRouteNames (routeNames = []) {
      let self = this
      return routeNames.includes(self.current_route_name)
    },
    onLogout () {
      let user = this.$user
      let clinic = this.$globalClinic
      this.sendAmplitude('Sign Out', {
        'doctor id': user && user.doctor && user.doctor.id ? user.doctor.id : '',
        'doctor name': user && user.name ? user.name : '',
        'workspace id': clinic && clinic.id ? clinic.id : '',
        'workspace name': clinic && clinic.name ? clinic.name : '',
        timestamp: window.moment(new Date()).format('HH:mm DD-MM-YYYY')
      })
      this.$emit('onLogout')
    },
    async getFeatureOrgList () {
      const id = this.$globalOrg?.id
      if (!id) return

      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgFeature(id)
        .then(r => {
          appUtils.setFeatureOrgList(r.data)
          this.$featureOrgList = appUtils.getFeatureOrgList()
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOpenHelpDocument () {
      window.open('https://docs.google.com/document/d/1-viLItTk2j1HdRkmTftJ_tJeerlAldD0ltXUG1bQWeg/edit', '_blank')
    },
    handleOpenEMR () {
      if (isMobile || isTablet) {
        window.open(this.emrMobileViewLink, '_blank')
      } else {
        this.$router.push({
          name: 'ListBenhAn'
        })
      }
    }
    // goToConversation () {
    //   const domain =
    //     window.location.hostname === 'localhost'
    //       ? 'http://localhost:3000'
    //       : process.env.VUE_APP_HODO_CONVERSATION
    //   const routeRaw = `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${
    //     this.$lang
    //   }`

    //   console.log(routeRaw)

    //   if (appUtils.checkIsMobile()) {
    //     let linkElement = document.createElement('a')
    //     const linkId = `conversation_id_${appUtils.randomStr(6, true)}`
    //     linkElement.id = linkId
    //     linkElement.href = routeRaw
    //     window.document.body.appendChild(linkElement)

    //     const linkEl = document.getElementById(linkId)
    //     linkEl.setAttribute('rel', 'noopener noreferrer')
    //     !appUtils.checkIsMobile() && linkEl.setAttribute('target', '_blank')
    //     linkEl.click()
    //     linkEl.remove()
    //     return
    //   }

    //   window.open(routeRaw, '_blank')
    // }
  }
}
</script>
<style lang="css" scoped>
.el-menu-item.is-active {
  background-color: #20409b !important;
}

.el-menu-item {
  padding: 0 15px !important;
}

.el-menu-item.is-active a {
  color: white !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #e4e7ec;
}

a {
  display: block;
  color: #03267a;
}

.alert-dot:before {
  content: attr(data-alter);
  position: absolute;
  font-family: FontAwesome;
  font-size: 13px;
  color: #dc0026;
  margin-left: 2px;
  font-weight: 700;
  height: 18px;
  width: 18px;
  background-color: #ffe8ec;
  right: 3px;
  top: 3px;
  border-radius: 10px;
  text-align: center;
  line-height: 15px;
}

.avatar-edit {
  background-image: url("../../../public/assets/images/icon/avatar_edit.svg");
  background-size: 15px 15px;
  width: 15px;
  height: 15px;
  margin-left: 28px;
  margin-top: -12px;
}

td,
th {
  vertical-align: middle !important;
}

.sb-infov2 {
  /*white-space: nowrap;*/
  /*overflow: hidden;*/
  margin-top: 32px;
  margin-bottom: 40px;
  padding-left: 18px;
  padding-right: 18px;
}

.sb-infov2 a:hover {
  text-decoration: none;
}

.sb-infov2:after {
  display: block;
  clear: both;
  content: "";
}

.sb-infov2-item {
  display: grid;
  grid-template-columns: 60px 160px;
}

.sb-infov2 .sb-info-avatar,
.sb-info .sb-info-name {
  display: inline-block;
}

.sb-infov2 .sb-info-avatar {
  margin-right: 13px;
}

.sb-infov2 .sb-info-avatar .avatar {
  --tblr-avatar-size: 44px;
}

.sb-infov2 .sb-info-name .dr-name {
  font-family: Roboto;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0em;
  color: black;
}

.sb-infov2 .sb-info-name .clinic-name {
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: left;
  color: #b6c2cf;
}

.left,
.right {
  float: left;
  height: 100vh;
}

.left {
  background: #337ab7;
  display: inline-block;
  white-space: nowrap;
  width: 50px;
  transition: width 1s;
}

.right {
  background: #fff;
  width: 350px;
  transition: width 1s;
  border-style: solid;
  border-color: #ccc;
  border-width: 1px;
}

.left:hover {
  width: 250px;
}

.item:hover {
  background-color: #ccc;
}

.left .sb-icon {
  margin: 15px;
  width: 20px;
  color: #fff;
}

.right .sb-icon {
  color: #a9a9a9;
}

span.sb-icon {
  vertical-align: middle !important;
}

.item {
  height: 50px;
  overflow: hidden;
  color: #fff;
}

.title {
  background-color: #eee;
  border-style: solid;
  border-color: #ccc;
  border-width: 1px;
  box-sizing: border-box;
}

.search:hover {
  border-color: #4aa9fb;
  border-width: 1px;
}

.search {
  padding: 3px 8px 3px !important;
}

input[type="search"] {
  padding: 10px 0px 10px;
  border: 0px solid #fff;
  background: #eee;
  -webkit-appearance: none;
  width: 90%;
  float: none;
}

input[type="search"]:focus {
  outline: none;
}

.type {
  height: 47px;
}

.date {
  background-color: #f7f7f7;
}

.docdate {
  vertical-align: bottom !important;
}

.distr {
  margin: 0 0 5px;
  font-size: 12px;
}

.ndoc {
  margin: 0 0 5px;
}

.storage {
  margin: 0;
  color: #aaa !important;
  font-size: 12px;
}

.relative {
  position: relative;
}

.red-dot-new {
  position: absolute;
  top: 3px;
  right: 3px;
}

.sb-link.disabled,
.pe-none {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.7;
}

.sb-main .pe-none .disabled {
  opacity: 1;
}

.fliped {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.noti-count {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d92d20;
  text-align: center;
  color: white;
  border-radius: 10px;
}

.cs-new {
  background-color: #d92d20;
  color: white;
  padding: 2px 4px;
  margin-bottom: 10px;
  border-radius: 10px;
  /* position: absolute;
  top: 0;
  right: 0; */
}

.ml-16 {
  margin-left: 58px;
}
</style>
